// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T18:16:30.982Z
// Property: Wilmington Apartments (ID: 6737460151192621)
// Collections: 16 amenities, 5 floorplans (live), 51 photos, 79 POIs, 4 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192621",
  "property_external_id": "4654598",
  "property_zillow_url": "https://www.zillow.com/apartments/north-little-rock-ar/wilmington/5XjKMw/",
  "property_apartments_url": "https://www.apartments.com/wilmington-apartments-north-little-rock-ar/6pf9zjs",
  "property_google_business_url": "https://www.google.com/maps/place/Wilmington+Apartments/data=!4m2!3m1!1s0x0:0x335d102e29402b68?sa=X&ved=2ahUKEwjNhLvYw7ySAxWK_7sIHTCCOEAQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321200797",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "wilmington-apartments",
  "property_name": "Wilmington Apartments",
  "property_website_url": "https://www.liveatwilmington.com/",
  "property_domain": "https://www.liveatwilmington.com/",
  "property_address": "617 Donovan Briley Blvd",
  "property_full_address": "617 Donovan Briley Blvd, North Little Rock, AR 72118",
  "property_address_1": "617 Donovan Briley Blvd",
  "property_address_2": null,
  "property_address_city": "North Little Rock",
  "property_address_state": "AR",
  "property_address_zip_full": "72118-3785",
  "property_address_zip": "72118",
  "property_address_country": "US",
  "property_address_county": "Pulaski County",
  "property_neighborhood_address": "North Little Rock",
  "property_address_latitude": "34.8150118",
  "property_address_longitude": "-92.2743321",
  "property_email": "wilmington@rreafresidential.com",
  "property_phone": "(501) 812-2067",
  "property_call_tracking_phone": "501-300-6726",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your ideal living space at Wilmington Apartments in North Little Rock, AR. With spacious two, three, and four-bedroom floor plans, enjoy exceptional amenities like a fitness center, clubhouse, and roof terrace. Find your new home today—browse our availability or schedule a tour of our vibrant community!",
  "property_long_description": "Welcome to Wilmington Apartments, your premier apartment community located in the heart of North Little Rock, AR. Featuring an array of thoughtfully designed floor plans, our community offers spacious two, three, and four-bedroom apartments perfect for families of all sizes. Each home is designed to maximize comfort and convenience, providing a sanctuary you’ll love coming home to.\n\nAt Wilmington Apartments, we pride ourselves on offering top-tier amenities that enhance your lifestyle. Stay fit and energized in our state-of-the-art fitness center, or unwind in our inviting clubhouse that fosters a sense of community. Enjoy breathtaking views and fresh air on our stunning roof terrace, the perfect spot for relaxing or entertaining friends. With controlled access and on-site maintenance, your peace of mind is our priority.\n\nOur friendly property manager is always on-site to assist you, ensuring all your needs are met. We also offer convenient services such as dry cleaning and a recycling program, making life easier and more eco-friendly. Plus, enjoy leisurely afternoons with friends in our lounge or fire up the grill for a delicious cookout.\n\nExplore our diverse floor plans and discover the perfect space tailored to your lifestyle. Whether you're looking for a contemporary two-bedroom or a spacious four-bedroom, Wilmington Apartments has the ideal home waiting for you. \n\nDon’t wait—find your new home today! Browse our availability or schedule a tour to visit our vibrant community and see all that Wilmington Apartments has to offer. Your next chapter starts here!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-aa10-76fe-9911-cc29a5a98205.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment building with manicured lawn and blue sky.",
    "public_id": "019e849c-aa10-76fe-9911-cc29a5a98205",
    "storage_key": "property/6737460151192621/019e849c-aa10-76fe-9911-cc29a5a98205.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "120",
  "property_year_built": "2002",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.66666666666667",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://wilmingtonapartments.loftliving.com/login",
  "property_apply_now_url": "https://8180571.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-a1ca-742a-8970-a1a7f69df4af.webp",
  "property_primary_logo_media": {
    "alt_text": "Wilmington Apartments logo",
    "public_id": "019e849c-a1ca-742a-8970-a1a7f69df4af",
    "storage_key": "property/6737460151192621/019e849c-a1ca-742a-8970-a1a7f69df4af.webp",
    "width": 1500,
    "height": 479
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-a1ca-742a-8970-a1a7f69df4af.webp",
  "property_secondary_logo_media": {
    "alt_text": "Wilmington Apartments logo",
    "public_id": "019e849c-a1ca-742a-8970-a1a7f69df4af",
    "storage_key": "property/6737460151192621/019e849c-a1ca-742a-8970-a1a7f69df4af.webp",
    "width": 1500,
    "height": 479
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-c2cc-75d5-ac82-da07e6fd191d.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e1e01-c2cc-75d5-ac82-da07e6fd191d",
    "storage_key": "property/6737460151192621/019e1e01-c2cc-75d5-ac82-da07e6fd191d.webp",
    "width": 1280,
    "height": 409
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e8e87-3f24-70cf-8afa-f55f6b886581.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-3f24-70cf-8afa-f55f6b886581",
    "storage_key": "property/6737460151192621/019e8e87-3f24-70cf-8afa-f55f6b886581.webp",
    "width": 1280,
    "height": 408
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 4",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2 - 2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "894 - 1276",
  "property_sqft_min": "894",
  "property_sqft_max": "1276",
  "property_price_range": "875 - 1399",
  "property_price_min": "875",
  "property_price_max": "1399",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/people/Wilmington-Apartments/61554105217509/",
  "property_instagram_url": "https://www.instagram.com/wilmington_apts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJt07YHRK90ocRaCtAKS4QXTM",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/wilmington-apartments-north-little-rock",
  "property_tiktok_url": "https://www.tiktok.com/@wilmington.apts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Wilmington Apartments",
  "property_home_romance_title": "Embrace Comfort and Connection at Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Experience the best at Wilmington Apartments! Our charming community is nestled in North Little Rock, Arkansas. We are conveniently located near Highway 176, making any commute a breeze. Enjoy easy access to family eateries, shopping, public parks, and entertainment hot spots. Wilmington Apartments <a href=\"/amenities/\">offers quality living</a> at affordable prices in a premier destination.</p>",
  "property_home_floorplans_blurb": "<p>Ideally located in North Little Rock, AR, the neighborhood surrounding Wilmington Apartments has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_home_gallery_blurb": "Welcome to Wilmington Apartments in North Little Rock, AR, where comfort meets convenience. Choose from spacious two, three, or four-bedroom floor plans and enjoy top-notch amenities like a refreshing pool, fitness center, and on-site laundry facilities. Picture yourself living here and embracing a vibrant lifestyle today!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Wilmington Apartments in North Little Rock, AR! With spacious two, three, and four-bedroom floor plans, our community offers both comfort and style. See what's around our community and explore local favorites and nearby points of interest that make Wilmington Apartments the perfect place to call home!",
  "property_home_reviews_blurb": "At Wilmington Apartments in North Little Rock, AR, residents rave about our \"clean property\" and \"friendly and professional\" staff. Enjoy a quiet oasis that’s perfect for families, with the added bonus of being zoned to Maumelle School District. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Ideally located in North Little Rock, AR, the neighborhood surrounding Wilmington Apartments has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Explore the <a href=\"/neighborhood/\">community</a> amenities at your disposal. Take a dip in our shimmering swimming pool. Enjoy some family fun in the play area. Please take advantage of our beautiful landscaping, and let your furry friends romp and play. Give us a call to schedule a tour; we can’t wait to show you your new home in Arkansas!</p>",
  "property_applynow_blurb": "Discover your ideal living space at Wilmington Apartments in North Little Rock, AR! Choose from our spacious two, three, or four-bedroom floor plans. Enjoy top-notch amenities like a fitness center, clubhouse, and roof terrace. Experience convenience and comfort—find your new home and lease online today!",
  "property_contactus_blurb": "Experience the perfect blend of space and comfort at Wilmington Apartments in North Little Rock, AR. Explore our diverse floor plans featuring two, three, and four-bedroom options tailored to your lifestyle. Have questions? Contact our leasing team today to find your ideal home!",
  "property_faqs_blurb": "Discover your perfect home at Wilmington Apartments in North Little Rock, AR! With spacious two, three, and four-bedroom floor plans, we cater to all lifestyles. Have questions? Browse our FAQs page for answers about our community and amenities, ensuring you make the best choice for your new apartment!",
  "property_floorplans_blurb": "<p>Choose from seven floor plans with a selection of two, three, and four bedroom apartment homes for rent. These spacious floor plans were built with your <a href=\"/amenities/\">comfort and convenience</a> in mind. Cook gourmet meals in your new all-electric kitchen equipped with a dishwasher and refrigerator. Your new home also comes designed with beautiful hardwood floors, central air and heating, and plush carpeted floors.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your ideal home at Wilmington Apartments in North Little Rock, AR! Choose from spacious two, three, or four-bedroom floor plans and enjoy premium amenities like a fitness center, clubhouse, and roof terrace. Use our interactive community map to search available apartments and find your perfect space today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover the perfect home at Wilmington Apartments in North Little Rock, AR! Choose from our spacious two, three, or four-bedroom floor plans, designed for your comfort. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy a life filled with connection and comfort!",
  "property_residentaccess_blurb": "Welcome to Wilmington Apartments in North Little Rock, AR! Explore our spacious two, three, and four-bedroom floor plans designed for modern living. Enjoy convenient resident access to pay rent, schedule maintenance, and manage your living experience effortlessly. Log in to your resident portal today for seamless service!",
  "property_reviews_blurb": "At Wilmington Apartments in North Little Rock, AR, residents enjoy a \"clean property\" and \"timely\" maintenance, supported by a friendly, professional staff. With a peaceful atmosphere and a vibrant community for kids, it's no wonder our tenants rave about their experiences. See what our residents have to say about living at our community!",
  "property_created_at": "1752257251380",
  "property_scheduletour_blurb": "Discover your ideal home at Wilmington Apartments in North Little Rock, AR. Choose from spacious two, three, or four-bedroom floor plans designed for comfort and convenience. Ready to experience community living? Schedule a tour today and see what our residents have to say about life at Wilmington Apartments!",
  "property_thankyou_blurb": "Thank you for your interest in Wilmington Apartments in North Little Rock, AR! Explore our diverse floor plans, featuring spacious two, three, and four-bedroom apartments designed for your comfort. A team member will reach out to you shortly to assist you on your journey to finding your perfect home!",
  "property_virtualtours_blurb": "<p>At Wilmington Apartments, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Wilmington Apartments",
  "property_seo_title_home": "Wilmington Apartments | Apartments in North Little Rock, AR",
  "property_seo_description_home": "Discover your perfect home at Wilmington Apartments in North Little Rock, AR! Explore our spacious floor plans featuring two, three, and four-bedroom options. Enjoy top-notch amenities such as a fitness center, clubhouse, elevator, and a stunning roof terrace, all within a controlled-access community. Our dedicated on-site property manager and maintenance team ensure your comfort, while conveniences like dry cleaning service and recycling elevate your lifestyle. Find your new home today and experience the vibrant living at Wilmington Apartments!",
  "property_seo_title_floorplans": "Floor Plans | 2 - 4 Apartments in North Little Rock, AR",
  "property_seo_description_floorplans": "Discover the ideal living space at Wilmington Apartments in North Little Rock, AR! Explore our diverse floor plans featuring spacious two, three, and four-bedroom options to suit your lifestyle. Browse our available apartment homes and find your perfect floor plan today!",
  "property_seo_title_amenities": "Amenities | North Little Rock, AR Apartments for Rent",
  "property_seo_description_amenities": "Discover Wilmington Apartments in North Little Rock, AR, where modern living meets comfort. Explore our range of thoughtfully designed floor plans—from cozy two-bedroom to spacious four-bedroom options. Enjoy top-notch amenities like a state-of-the-art fitness center, a relaxing clubhouse, a scenic roof terrace, and convenient dry cleaning services. With controlled access, on-site maintenance, and a dedicated property manager, your peace of mind is our priority. Dive into an elevated lifestyle that offers more than just a home. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in North Little Rock, AR",
  "property_seo_description_gallery": "Explore the captivating photo gallery of Wilmington Apartments in North Little Rock, AR! Discover a vibrant community featuring spacious two, three, and four-bedroom floor plans, along with top-notch amenities like a fitness center, clubhouse, and rooftop terrace. Experience luxury living with controlled access, on-site maintenance, and convenient services. Picture yourself enjoying life here – your dream apartment awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Wilmington Apartments Apartments",
  "property_seo_description_virtualtours": "Explore Wilmington Apartments in North Little Rock, AR, where comfort meets style! Discover spacious floor plans that include two, three, and four-bedroom options to fit your lifestyle. Ready to see more? Take a virtual tour of our community and apartments for rent today! Don’t miss out on your perfect home!",
  "property_seo_title_interactivemap": "Interactive Map | Wilmington Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Wilmington Apartments in North Little Rock, AR! Explore our spacious two, three, and four-bedroom floor plans, designed for comfort and convenience. Enjoy top-notch amenities including a fitness center, rooftop terrace, clubhouse, and on-site maintenance. Use our interactive community map to find available apartments and pricing today! Your ideal apartment awaits at Wilmington Apartments—where community and lifestyle meet.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Little Rock, AR",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Wilmington Apartments in North Little Rock, AR! Explore local favorites and nearby points of interest while choosing from our spacious two, three, and four-bedroom floor plans. See what's around our community and immerse yourself in the rich culture and convenience at Wilmington Apartments.",
  "property_seo_title_contact": "Contact Us | Wilmington Apartments",
  "property_seo_description_contact": "Discover your perfect home at Wilmington Apartments in North Little Rock, AR! Explore our spacious two, three, and four-bedroom floor plans designed for comfort and style. Have questions? Contact our leasing team today and let us help you find your ideal living space!",
  "property_seo_title_faqs": "FAQs | Apartments in North Little Rock, AR",
  "property_seo_description_faqs": "Discover the ultimate living experience at Wilmington Apartments in North Little Rock, AR! Our community offers spacious two, three, and four-bedroom floor plans designed to fit your lifestyle. Enjoy top-notch amenities including a fitness center, clubhouse, and stunning roof terrace. With controlled access, on-site maintenance, and services like dry cleaning, we prioritize your comfort. Have questions? Browse our FAQs page to find answers and learn more about your future home. Join us today and elevate your living experience!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Little Rock, AR",
  "property_seo_description_reviews": "Discover why residents love Wilmington Apartments in North Little Rock, AR! Explore our spacious two, three, and four-bedroom floor plans, along with exceptional amenities like a fitness center, clubhouse, and rooftop terrace. Enjoy peace of mind with controlled access and on-site maintenance. Don’t just take our word for it—see what our residents have to say about their experiences in our vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in North Little Rock, AR",
  "property_seo_description_applynow": "Discover your ideal living space at Wilmington Apartments in North Little Rock, AR! Explore our diverse floor plans, featuring two, three, and four-bedroom layouts to suit your lifestyle. Enjoy top-notch amenities, including a fitness center, clubhouse, roof terrace, and 24/7 on-site maintenance. Experience the convenience of controlled access, dry cleaning services, and our eco-friendly recycling program. Ready to call Wilmington Apartments home? Apply now and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Wilmington Apartments",
  "property_seo_description_residentaccess": "\"Welcome to Wilmington Apartments in North Little Rock, AR! Access your resident portal now to pay rent, schedule maintenance, and enjoy convenient community features. Stay connected and manage your apartment effortlessly!\"",
  "property_seo_title_referafriend": "Refer A Friend | Wilmington Apartments",
  "property_seo_description_referafriend": "\"Spread the word about Wilmington Apartments in North Little Rock, AR! Great friends make great neighbors—refer a friend to our vibrant community today and enjoy exclusive rewards together. Join us for a welcoming living experience!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Wilmington Apartments",
  "property_seo_description_scheduletour": "Discover your ideal home at Wilmington Apartments in North Little Rock, AR! Schedule a tour of our stunning community today and experience modern living with top-notch amenities. Don’t miss the chance to find your perfect apartment!",
  "property_seo_title_privacy": "Privacy Policy | Wilmington Apartments",
  "property_seo_description_privacy": "Discover peace of mind at Wilmington Apartments in North Little Rock, AR. Our privacy policy outlines how we protect your personal information and ensure a safe living experience. View our privacy policy today for complete transparency and assurance in your apartment community!",
  "property_seo_title_accessibility": "Website Accessibility | Wilmington Apartments",
  "property_seo_description_accessibility": "\"Discover Wilmington Apartments in North Little Rock, AR, where accessibility meets comfort! Our commitment to digital inclusion ensures all residents can easily connect with community resources. Explore our Accessibility Statement to learn how we prioritize an inclusive living experience for everyone. Join us today!\"",
  "property_seo_title_sitemap": "Sitemap | Wilmington Apartments",
  "property_seo_description_sitemap": "Discover everything Wilmington Apartments in North Little Rock, AR has to offer! Explore our sitemap to find the latest amenities, floor plans, and community features. Navigate easily to make your home search smooth and convenient. View our website sitemap now!",
  "property_seo_title_thankyou": "Thank You | Wilmington Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in Wilmington Apartments in North Little Rock, AR! Your submission has been received, and a member of our friendly team will be in touch shortly to assist you in finding your perfect home. Stay tuned for exciting updates and more information about our welcoming community!",
  "property_seo_title_pets": "Pet Policy | Apartments in North Little Rock, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293558640",
  "amenities": [
    {
      "id": "ec_6ca3d619500c93a2391a9a8a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "Found under COMMUNITY AMENITIES list on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eed619a3bf02bc8d3b241d54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Easy Access to Shopping",
      "amount": "false",
      "description": "Found under COMMUNITY AMENITIES list on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2aecff9608295a2c792b6719",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Military Discounts",
      "amount": "false",
      "description": "Found under COMMUNITY AMENITIES list on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af8209f92c1dcd776e6d0141",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "On‑call Maintenance",
      "amount": "false",
      "description": "Found under COMMUNITY AMENITIES list on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51393c9a54c8827975779271",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Play Area",
      "amount": "false",
      "description": "Found under COMMUNITY AMENITIES list; also appears in introductory text referencing ‘play area’.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40c47ebd146f1ff4886c8b7a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Public Parks Nearby",
      "amount": "false",
      "description": "Found under COMMUNITY AMENITIES list on the official amenities page.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_625d1bce215db3c6023164b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "Found under COMMUNITY AMENITIES list; also appears in slide headings.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1049067d4c203ce75db03bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "Found under COMMUNITY AMENITIES list; also appears in introductory text referencing ‘shimmering swimming pool’.",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_122ada9fd59185e56e7d67a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "All‑electric Kitchen",
      "amount": "false",
      "description": "Found under APARTMENT FEATURES heading with exact title match.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30651b716472a2612d75ca50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Carpeted Floors",
      "amount": "false",
      "description": "Found under APARTMENT FEATURES with exact title match.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f78ec3682c03af16bd100623",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Central Air and Heating",
      "amount": "false",
      "description": "Found under APARTMENT FEATURES with exact title match.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c75c317e84b07c6419f6ef86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "Found under APARTMENT FEATURES with exact title match.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25a4ec417d8e0b8b09d83126",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "Found under APARTMENT FEATURES with exact title match (as “Hardwood Floors”).",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb506a82d26aac3ed8fb7ece",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Mini Blinds",
      "amount": "false",
      "description": "Found under APARTMENT FEATURES with exact title match.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfe3827e022c244db61f10b5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "Found under APARTMENT FEATURES with exact title match.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ea07d3b50f2dc55437323de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "Found under APARTMENT FEATURES with exact title match (“Washer and Dryer Connections”).",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_da127530-0210-4e40-8e4e-6ebc84334953",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-7faf-702a-883e-73d382fbbb69.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with manicured lawns and blue sky.",
        "public_id": "019e849c-7faf-702a-883e-73d382fbbb69",
        "storage_key": "property/6737460151192621/019e849c-7faf-702a-883e-73d382fbbb69.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in these apartment buildings, featuring well-maintained exteriors and lush green spaces.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with manicured lawns and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96eb98e7-b458-4d85-94d6-e8d5ff978474",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-8410-75aa-a974-9912d72697c4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, with apartment buildings in the background.",
        "public_id": "019e849c-8410-75aa-a974-9912d72697c4",
        "storage_key": "property/6737460151192621/019e849c-8410-75aa-a974-9912d72697c4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and umbrellas for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f34a817e-c564-483c-b233-e92f428654c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849d-0635-75f1-a6b8-c933ee038b6a.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, ottoman, and console table.",
        "public_id": "019e849d-0635-75f1-a6b8-c933ee038b6a",
        "storage_key": "property/6737460151192621/019e849d-0635-75f1-a6b8-c933ee038b6a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush sofa, decorative ottoman, and elegant console table, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, ottoman, and console table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c67824da-eac0-4bd9-82f5-bf2d127c4d16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-f351-77f1-bdaa-603e6b4fae83.webp",
      "image_media": {
        "alt_text": "A beautifully decorated bedroom with a queen-size bed and a nightstand.",
        "public_id": "019e849c-f351-77f1-bdaa-603e6b4fae83",
        "storage_key": "property/6737460151192621/019e849c-f351-77f1-bdaa-603e6b4fae83.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and inviting bedroom featuring a plush queen-size bed with elegant blue bedding and a stylish nightstand. Perfect for relaxation.",
      "link": "",
      "alt_text": "A beautifully decorated bedroom with a queen-size bed and a nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_52ab4287-1609-41cb-bb6f-6979e355cf2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-ffd6-77dc-9e6b-4d888834a6ec.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment.",
        "public_id": "019e849c-ffd6-77dc-9e6b-4d888834a6ec",
        "storage_key": "property/6737460151192621/019e849c-ffd6-77dc-9e6b-4d888834a6ec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a meal with loved ones in this stylish dining area, adjacent to a well-equipped kitchen.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24879b80-a257-49b0-a034-3d562776ab0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-ff19-723d-9962-05369688c186.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel sink, granite countertops, and dark wood cabinets.",
        "public_id": "019e849c-ff19-723d-9962-05369688c186",
        "storage_key": "property/6737460151192621/019e849c-ff19-723d-9962-05369688c186.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and style of this modern kitchen, featuring a deep stainless steel sink, elegant granite countertops, and rich dark wood cabinetry. Perfect for everyday living and entertaining.",
      "link": "",
      "alt_text": "Kitchen with stainless steel sink, granite countertops, and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_258c8d38-f5c6-418e-9471-fd1d0a918a42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-d4e1-715a-bc23-a07ee0971f17.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019e849c-d4e1-715a-bc23-a07ee0971f17",
        "storage_key": "property/6737460151192621/019e849c-d4e1-715a-bc23-a07ee0971f17.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment kitchen features sleek dark wood cabinetry, a black stove and refrigerator, and elegant granite countertops for a stylish cooking experience.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_850a69ca-597d-4cf3-ab20-296f59a0fbe0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-ee22-74fc-b472-09dcfae60672.webp",
      "image_media": {
        "alt_text": "Bedroom with a large blue velvet bed, dresser, and closet doors.",
        "public_id": "019e849c-ee22-74fc-b472-09dcfae60672",
        "storage_key": "property/6737460151192621/019e849c-ee22-74fc-b472-09dcfae60672.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-sized bed, elegant decor, and ample closet space.",
      "link": "",
      "alt_text": "Bedroom with a large blue velvet bed, dresser, and closet doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_47d82499-55da-4e15-ba36-96c28fb2f6a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-e7c2-72db-b1d5-133ac7807216.webp",
      "image_media": {
        "alt_text": "Living room with entry door and window, wood-look flooring.",
        "public_id": "019e849c-e7c2-72db-b1d5-133ac7807216",
        "storage_key": "property/6737460151192621/019e849c-e7c2-72db-b1d5-133ac7807216.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this inviting living space featuring a neutral color palette, a white entry door, and wood-look laminate flooring. The room is brightened by natural light from the window.",
      "link": "",
      "alt_text": "Living room with entry door and window, wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30ba01a9-e61b-4847-8cd8-aba1dbe61d60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-e2d4-7049-9a79-0edc21145193.webp",
      "image_media": {
        "alt_text": "Interior of a modern apartment with wood-look flooring, a neutral color palette, and an open-concept kitchen visible in the background.",
        "public_id": "019e849c-e2d4-7049-9a79-0edc21145193",
        "storage_key": "property/6737460151192621/019e849c-e2d4-7049-9a79-0edc21145193.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and inviting living area with elegant wood-look flooring, leading into a contemporary kitchen. Perfect for comfortable living and entertaining.",
      "link": "",
      "alt_text": "Interior of a modern apartment with wood-look flooring, a neutral color palette, and an open-concept kitchen visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d66f243d-c6fe-4efd-86cc-44ee0b80a90b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-f334-71ad-9d51-bf9837abb280.webp",
      "image_media": {
        "alt_text": "Bathroom with a white bathtub, toilet, and vanity with a marbled countertop.",
        "public_id": "019e849c-f334-71ad-9d51-bf9837abb280",
        "storage_key": "property/6737460151192621/019e849c-f334-71ad-9d51-bf9837abb280.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This bright bathroom features a clean white bathtub and toilet, complemented by a dark wood vanity with a stunning marbled countertop. An orchid arrangement adds a touch of elegance.",
      "link": "",
      "alt_text": "Bathroom with a white bathtub, toilet, and vanity with a marbled countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36feac7c-4eee-4e26-b76f-67f2684f1c96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-b2c2-7209-95b8-cf73085de5dd.webp",
      "image_media": {
        "alt_text": "Living room with sofa, chairs, and dining area",
        "public_id": "019e849c-b2c2-7209-95b8-cf73085de5dd",
        "storage_key": "property/6737460151192621/019e849c-b2c2-7209-95b8-cf73085de5dd.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, elegant armchairs, and a dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with sofa, chairs, and dining area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_287fee11-86a9-4743-bd88-ce11862adc50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-d5fe-77a4-afc5-952880b358f6.webp",
      "image_media": {
        "alt_text": "Bedroom with a daybed, abstract art, and closet.",
        "public_id": "019e849c-d5fe-77a4-afc5-952880b358f6",
        "storage_key": "property/6737460151192621/019e849c-d5fe-77a4-afc5-952880b358f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable daybed, large abstract artwork, and access to a walk-in closet and ensuite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a daybed, abstract art, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d84f71d4-6155-48e4-a438-1572e26e4fea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-d40e-749f-b531-2650498a462a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, black appliances, and wood-look flooring.",
        "public_id": "019e849c-d40e-749f-b531-2650498a462a",
        "storage_key": "property/6737460151192621/019e849c-d40e-749f-b531-2650498a462a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this modern kitchen featuring sleek dark wood cabinetry, elegant granite countertops, and essential black appliances. The durable wood-look flooring completes the contemporary aesthetic.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, black appliances, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92b06059-516b-4949-961c-c685a1aeecbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-ca73-74ff-9c5b-5ba4349db911.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige carpet and a window with blinds.",
        "public_id": "019e849c-ca73-74ff-9c5b-5ba4349db911",
        "storage_key": "property/6737460151192621/019e849c-ca73-74ff-9c5b-5ba4349db911.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with soft beige carpeting and a large window, offering a neutral and inviting atmosphere.",
      "link": "",
      "alt_text": "Empty bedroom with beige carpet and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_887a80bd-1708-4c2e-81b3-0d63eac2cae9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-d101-7257-b5e9-0644f5ad2c15.webp",
      "image_media": {
        "alt_text": "A bedroom with a desk and a daybed, featuring a large mirror and abstract art.",
        "public_id": "019e849c-d101-7257-b5e9-0644f5ad2c15",
        "storage_key": "property/6737460151192621/019e849c-d101-7257-b5e9-0644f5ad2c15.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this beautifully appointed bedroom, featuring a sleek desk with a vanity mirror and a cozy daybed perfect for relaxation.",
      "link": "",
      "alt_text": "A bedroom with a desk and a daybed, featuring a large mirror and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5197c9ff-4b05-4cc4-88c1-1c2736154558",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-cb11-732c-b0f0-fce7a6ce2a47.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls and carpet, featuring a window with blinds and a ceiling vent.",
        "public_id": "019e849c-cb11-732c-b0f0-fce7a6ce2a47",
        "storage_key": "property/6737460151192621/019e849c-cb11-732c-b0f0-fce7a6ce2a47.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This empty bedroom offers a blank canvas for you to personalize. Neutral walls and plush carpeting create a cozy atmosphere, while the window provides natural light.",
      "link": "",
      "alt_text": "Empty bedroom with beige walls and carpet, featuring a window with blinds and a ceiling vent.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b35934a-00c3-4786-8415-b4bf07bfb05d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-ca68-754a-94c6-d43545a2bcd9.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a white door and a window with blinds.",
        "public_id": "019e849c-ca68-754a-94c6-d43545a2bcd9",
        "storage_key": "property/6737460151192621/019e849c-ca68-754a-94c6-d43545a2bcd9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and carpeted empty bedroom with a neutral-toned wall, a window with blinds, and a white door. This room is ready for you to make it your own.",
      "link": "",
      "alt_text": "Empty bedroom with a white door and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83ddfdca-473d-4fd7-81e4-11341b98ced6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-c454-748d-9409-e0fd9ded02d1.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, window, and closet.",
        "public_id": "019e849c-c454-748d-9409-e0fd9ded02d1",
        "storage_key": "property/6737460151192621/019e849c-c454-748d-9409-e0fd9ded02d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with neutral paint, plush carpeting, and a large closet, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, window, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6abb374b-7786-43a9-954d-1e5a2974824d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-bab4-76af-82b6-ebe6822476db.webp",
      "image_media": {
        "alt_text": "Seating area with table and chairs near leasing office desk.",
        "public_id": "019e849c-bab4-76af-82b6-ebe6822476db",
        "storage_key": "property/6737460151192621/019e849c-bab4-76af-82b6-ebe6822476db.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy a comfortable seating area with a table and chairs, perfect for residents or guests, located conveniently near the leasing office.",
      "link": "",
      "alt_text": "Seating area with table and chairs near leasing office desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a3481c1a-e63f-4d18-afed-7b43f142870a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-bd41-73b3-9945-55966ae864f8.webp",
      "image_media": {
        "alt_text": "Interior view of a stylish lounge area with leather chairs, a bench, and decorative artwork.",
        "public_id": "019e849c-bd41-73b3-9945-55966ae864f8",
        "storage_key": "property/6737460151192621/019e849c-bd41-73b3-9945-55966ae864f8.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed resident lounge, featuring comfortable seating and modern decor. A perfect space to socialize or enjoy some quiet time.",
      "link": "",
      "alt_text": "Interior view of a stylish lounge area with leather chairs, a bench, and decorative artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1af9ee97-4849-487d-9be5-cc18f4eeeedd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-b70d-7248-b9b8-f537d1351760.webp",
      "image_media": {
        "alt_text": "Lobby area with a dining table and chairs, a seating area, and decorative shelving.",
        "public_id": "019e849c-b70d-7248-b9b8-f537d1351760",
        "storage_key": "property/6737460151192621/019e849c-b70d-7248-b9b8-f537d1351760.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Lobby area featuring a modern dining set, comfortable seating, and stylish decor, perfect for residents to relax or gather.",
      "link": "",
      "alt_text": "Lobby area with a dining table and chairs, a seating area, and decorative shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3ff4787b-1fa4-45ca-aa33-fb7c7f3a99be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-aa10-76fe-9911-cc29a5a98205.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with manicured lawn and blue sky.",
        "public_id": "019e849c-aa10-76fe-9911-cc29a5a98205",
        "storage_key": "property/6737460151192621/019e849c-aa10-76fe-9911-cc29a5a98205.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment exterior featuring a well-maintained lawn and a clear blue sky. Offers a welcoming and serene environment.",
      "link": "",
      "alt_text": "Exterior view of apartment building with manicured lawn and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27ce13a6-8cd5-4056-a66f-1a4dd16e6ec1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-b423-734e-bfea-93b73116fe29.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, ottoman, and entryway to bedroom.",
        "public_id": "019e849c-b423-734e-bfea-93b73116fe29",
        "storage_key": "property/6737460151192621/019e849c-b423-734e-bfea-93b73116fe29.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, a stylish armchair, and ottomans, with a view into a well-appointed bedroom.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, ottoman, and entryway to bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e41ed66-1206-48c0-81ca-1fe1d728cd85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-a3b8-7589-af4f-1d182b3da2cd.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and apartment buildings in the background.",
        "public_id": "019e849c-a3b8-7589-af4f-1d182b3da2cd",
        "storage_key": "property/6737460151192621/019e849c-a3b8-7589-af4f-1d182b3da2cd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, featuring agility equipment for your furry friends, with scenic apartment buildings in the background.",
      "link": "",
      "alt_text": "Dog park with agility equipment and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02ec874d-d78d-4d5a-8e61-40729f867cd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-b5f0-70ed-8ddb-89079415ae87.webp",
      "image_media": {
        "alt_text": "Bathroom with white tub, toilet, and vanity with sink and dark wood cabinets.",
        "public_id": "019e849c-b5f0-70ed-8ddb-89079415ae87",
        "storage_key": "property/6737460151192621/019e849c-b5f0-70ed-8ddb-89079415ae87.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a white bathtub, toilet, and a spacious vanity with a granite countertop and dark wood cabinetry.",
      "link": "",
      "alt_text": "Bathroom with white tub, toilet, and vanity with sink and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5d8626f-4bbb-4755-a097-4636c2fa7c3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-b3aa-7010-a436-c025be64cddc.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and mirror.",
        "public_id": "019e849c-b3aa-7010-a436-c025be64cddc",
        "storage_key": "property/6737460151192621/019e849c-b3aa-7010-a436-c025be64cddc.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a sleek dresser with a mirror, and elegant decor.",
      "link": "",
      "alt_text": "Bedroom with a bed, dresser, and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c67d948-077b-42c5-80cb-93bba121ba10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-a3f9-74b7-beb4-2468aa85f585.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table in front of apartment buildings.",
        "public_id": "019e849c-a3f9-74b7-beb4-2468aa85f585",
        "storage_key": "property/6737460151192621/019e849c-a3f9-74b7-beb4-2468aa85f585.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool, complete with comfortable lounge chairs and convenient tables. Perfect for unwinding and soaking up the sun.",
      "link": "",
      "alt_text": "Swimming pool area with lounge chairs and a table in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1b3ca543-a383-45e8-9bd4-5d89c3240381",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-ad9f-70f6-9c6e-4d460c1ce59b.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "019e849c-ad9f-70f6-9c6e-4d460c1ce59b",
        "storage_key": "property/6737460151192621/019e849c-ad9f-70f6-9c6e-4d460c1ce59b.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom featuring a plush queen-size bed and convenient nightstand.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_09238462-ad5a-4695-ade8-cfeec63c2a6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-a83b-7674-950f-6f3b1e70e9d5.webp",
      "image_media": {
        "alt_text": "Bedroom with a desk, chair, and bed.",
        "public_id": "019e849c-a83b-7674-950f-6f3b1e70e9d5",
        "storage_key": "property/6737460151192621/019e849c-a83b-7674-950f-6f3b1e70e9d5.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "A well-appointed bedroom featuring a desk and chair, perfect for a home office space, and a comfortable bed.",
      "link": "",
      "alt_text": "Bedroom with a desk, chair, and bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_abdb7ba5-fbd4-4f83-8e51-efde02675cf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-9de4-7779-ae04-dee599711be0.webp",
      "image_media": {
        "alt_text": "Sparkling blue outdoor swimming pool with lounge chairs and a clubhouse in the background.",
        "public_id": "019e849c-9de4-7779-ae04-dee599711be0",
        "storage_key": "property/6737460151192621/019e849c-9de4-7779-ae04-dee599711be0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, perfect for relaxing and unwinding on sunny days. Adjacent clubhouse offers additional amenities.",
      "link": "",
      "alt_text": "Sparkling blue outdoor swimming pool with lounge chairs and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e6b3576-c14b-4356-aab0-d637a969d4d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-827c-72ab-81df-721b36c84401.webp",
      "image_media": {
        "alt_text": "Exterior building with picnic table and grassy area.",
        "public_id": "019e849c-827c-72ab-81df-721b36c84401",
        "storage_key": "property/6737460151192621/019e849c-827c-72ab-81df-721b36c84401.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors at this community property with a picnic table and ample green space.",
      "link": "",
      "alt_text": "Exterior building with picnic table and grassy area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0b0baee-d1db-4b53-97a7-ddc5e1865f7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-a6c5-71af-945b-3294b9f677bd.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019e849c-a6c5-71af-945b-3294b9f677bd",
        "storage_key": "property/6737460151192621/019e849c-a6c5-71af-945b-3294b9f677bd.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, granite countertops, and black appliances, including a refrigerator and stove.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b11fb04-933a-4a81-8421-84ee2b64169c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-a5b6-72a4-bdc6-e5d174f11b93.webp",
      "image_media": {
        "alt_text": "Playground equipment with a slide and monkey bars on a dark wood chip ground cover.",
        "public_id": "019e849c-a5b6-72a4-bdc6-e5d174f11b93",
        "storage_key": "property/6737460151192621/019e849c-a5b6-72a4-bdc6-e5d174f11b93.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a colorful slide and monkey bars for endless entertainment.",
      "link": "",
      "alt_text": "Playground equipment with a slide and monkey bars on a dark wood chip ground cover.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d784e718-56ef-41bd-be78-338067f2e558",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-a4ff-7648-82ad-3d78bbcf1bd1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a dining area with blue chairs.",
        "public_id": "019e849c-a4ff-7648-82ad-3d78bbcf1bd1",
        "storage_key": "property/6737460151192621/019e849c-a4ff-7648-82ad-3d78bbcf1bd1.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Enjoy a modern living experience in this apartment featuring a well-equipped kitchen with granite countertops, stainless steel appliances, and a cozy dining nook.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a dining area with blue chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb03dda0-9ec4-4b66-8ddd-8e5cc468637d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-864d-737e-994a-231be5b58eb9.webp",
      "image_media": {
        "alt_text": "Exterior view of a beige apartment building with white fencing and green grass.",
        "public_id": "019e849c-864d-737e-994a-231be5b58eb9",
        "storage_key": "property/6737460151192621/019e849c-864d-737e-994a-231be5b58eb9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in this charming apartment building, featuring a well-maintained exterior with white fencing and lush green spaces.",
      "link": "",
      "alt_text": "Exterior view of a beige apartment building with white fencing and green grass.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fa68c6f1-994b-400e-8cb3-62478b82b5d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-8021-75a9-952b-27aaf1924930.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019e849c-8021-75a9-952b-27aaf1924930",
        "storage_key": "property/6737460151192621/019e849c-8021-75a9-952b-27aaf1924930.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded by umbrellas. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_837e8975-a7d9-4cd0-94c9-10c49f78fd49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-802b-74b4-8e0e-d8c9f505e4eb.webp",
      "image_media": {
        "alt_text": "Community swimming pool with lounge chairs and tables.",
        "public_id": "019e849c-802b-74b4-8e0e-d8c9f505e4eb",
        "storage_key": "property/6737460151192621/019e849c-802b-74b4-8e0e-d8c9f505e4eb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool in this community's outdoor swimming area, complete with comfortable lounge chairs and shaded seating.",
      "link": "",
      "alt_text": "Community swimming pool with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aba991c3-dc4b-456c-82fe-f73e2511ce09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-811c-70c9-a383-e040e868588d.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019e849c-811c-70c9-a383-e040e868588d",
        "storage_key": "property/6737460151192621/019e849c-811c-70c9-a383-e040e868588d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f15e2d28-f509-486c-b843-cb8dffea8e6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-7e1c-772f-ad02-309e9c40e41e.webp",
      "image_media": {
        "alt_text": "Entrance of the community building with a sign indicating future resident parking.",
        "public_id": "019e849c-7e1c-772f-ad02-309e9c40e41e",
        "storage_key": "property/6737460151192621/019e849c-7e1c-772f-ad02-309e9c40e41e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the community! This image shows the entrance to the main building, with signage for future resident parking. Enjoy our beautiful grounds and amenities.",
      "link": "",
      "alt_text": "Entrance of the community building with a sign indicating future resident parking.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1216c7f3-16ae-427d-83b7-e1f6019a898c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-8320-7120-a772-877d7358023f.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with table and orange chairs under an umbrella, picnic table and building in the background.",
        "public_id": "019e849c-8320-7120-a772-877d7358023f",
        "storage_key": "property/6737460151192621/019e849c-8320-7120-a772-877d7358023f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors at our community's picnic and seating area, perfect for relaxing or dining al fresco.",
      "link": "",
      "alt_text": "Outdoor seating area with table and orange chairs under an umbrella, picnic table and building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_98114e5d-1c82-47c2-ad05-0404147d2317",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e849c-7bf2-77dd-834d-3c5dd7e45f38.webp",
      "image_media": {
        "alt_text": "Lobby seating area with two grey armchairs, two benches, and two nesting coffee tables.",
        "public_id": "019e849c-7bf2-77dd-834d-3c5dd7e45f38",
        "storage_key": "property/6737460151192621/019e849c-7bf2-77dd-834d-3c5dd7e45f38.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our stylish lobby seating area, featuring comfortable armchairs and benches, perfect for waiting or meeting guests.",
      "link": "",
      "alt_text": "Lobby seating area with two grey armchairs, two benches, and two nesting coffee tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f78d5103-66e2-4847-848b-b3cd1e796ee6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/01a0f914-2789-7024-a193-c477e7b90bd2.webp",
      "image_media": {
        "alt_text": "Modern dining area with a table and chairs next to a large window and a stylish shelving unit.",
        "public_id": "01a0f914-2789-7024-a193-c477e7b90bd2",
        "storage_key": "property/6737460151192621/01a0f914-2789-7024-a193-c477e7b90bd2.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy your meals in this bright and airy dining space, perfect for intimate dinners or casual gatherings. The open-concept design flows seamlessly into the living area.",
      "link": "",
      "alt_text": "Modern dining area with a table and chairs next to a large window and a stylish shelving unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_377a6804-dfdf-44dd-9347-a39548956d8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/01a0f914-2a66-71b8-93f0-18cff2e64679.webp",
      "image_media": {
        "alt_text": "A stylish desk with a mirror above it and a chair in front of it, next to a bed.",
        "public_id": "01a0f914-2a66-71b8-93f0-18cff2e64679",
        "storage_key": "property/6737460151192621/01a0f914-2a66-71b8-93f0-18cff2e64679.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A well-appointed bedroom featuring a chic vanity desk, a comfortable bed, and elegant decor, creating a serene and inviting atmosphere.",
      "link": "",
      "alt_text": "A stylish desk with a mirror above it and a chair in front of it, next to a bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_057dc91f-a29d-4439-9a6f-563ef4d06c5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/01a0f914-2624-76df-accb-66b45439ee55.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "01a0f914-2624-76df-accb-66b45439ee55",
        "storage_key": "property/6737460151192621/01a0f914-2624-76df-accb-66b45439ee55.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush queen-size bed with navy blue and cream linens, a modern nightstand with a lamp, and a large window with sheer curtains.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed11094e-25f4-41aa-a7c1-beab438430a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/01a0f914-2616-703e-a96c-5cd62963ec0b.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs and umbrellas with apartment buildings in the background.",
        "public_id": "01a0f914-2616-703e-a96c-5cd62963ec0b",
        "storage_key": "property/6737460151192621/01a0f914-2616-703e-a96c-5cd62963ec0b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. It's the perfect spot to relax and soak up the sun.",
      "link": "",
      "alt_text": "Swimming pool area with lounge chairs and umbrellas with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c5f0a37-4499-4d00-a464-f0f45d641ff3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/01a0f914-268e-759c-bf5a-2b8938be6b14.webp",
      "image_media": {
        "alt_text": "Dining area with marble table and blue velvet chairs next to kitchen with black appliances.",
        "public_id": "01a0f914-268e-759c-bf5a-2b8938be6b14",
        "storage_key": "property/6737460151192621/01a0f914-268e-759c-bf5a-2b8938be6b14.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, featuring a stylish marble table and plush blue velvet chairs, adjacent to a modern kitchen with black appliances and ample counter space.",
      "link": "",
      "alt_text": "Dining area with marble table and blue velvet chairs next to kitchen with black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed89331a-c971-47c5-8e35-f4c03edcf214",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/01a0f914-269e-71fd-8995-5fbf0a81caf9.webp",
      "image_media": {
        "alt_text": "Modern living room with sofa, chair, ottoman, and view into kitchen.",
        "public_id": "01a0f914-269e-71fd-8995-5fbf0a81caf9",
        "storage_key": "property/6737460151192621/01a0f914-269e-71fd-8995-5fbf0a81caf9.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and stylish living area, perfect for relaxing or entertaining, with an open view to the kitchen.",
      "link": "",
      "alt_text": "Modern living room with sofa, chair, ottoman, and view into kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ce6f1f20-d8ad-45c0-b10e-d5980c79f158",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/01a0f914-2725-752d-a520-0eaed0e51137.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "01a0f914-2725-752d-a520-0eaed0e51137",
        "storage_key": "property/6737460151192621/01a0f914-2725-752d-a520-0eaed0e51137.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97293231-0bb4-4e77-92f0-de786322af64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/01a0f914-260e-70db-90b4-b42ff9dc9cf7.webp",
      "image_media": {
        "alt_text": "Modern lobby seating area with armchairs, a bench, coffee tables, and decorative lamps.",
        "public_id": "01a0f914-260e-70db-90b4-b42ff9dc9cf7",
        "storage_key": "property/6737460151192621/01a0f914-260e-70db-90b4-b42ff9dc9cf7.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lobby, featuring comfortable seating and modern decor.",
      "link": "",
      "alt_text": "Modern lobby seating area with armchairs, a bench, coffee tables, and decorative lamps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9863acbc-e362-43bb-8b57-e9269303a0ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/01a0f914-27aa-74de-a07b-fef6f8a8d6f6.webp",
      "image_media": {
        "alt_text": "Playground with monkey bars and climbing structures.",
        "public_id": "01a0f914-27aa-74de-a07b-fef6f8a8d6f6",
        "storage_key": "property/6737460151192621/01a0f914-27aa-74de-a07b-fef6f8a8d6f6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring exciting climbing structures and monkey bars for children of all ages.",
      "link": "",
      "alt_text": "Playground with monkey bars and climbing structures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_610bccb8-ce9a-4757-b393-690e49f8fe7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Flyway Brewing",
      "poi_type": "Restaurants",
      "poi_address": "314 Maple St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-4e9a-7611-bb33-e35ad6f9296e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-4e9a-7611-bb33-e35ad6f9296e",
        "storage_key": "property/6737460151192621/019e1e03-4e9a-7611-bb33-e35ad6f9296e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flywaybrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9212740221938584033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flyway-brewing",
      "poi_latitude": "34.7567912",
      "poi_longitude": "-92.2688016",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-812-3192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yyyxIO80ocR4UmasGs62n8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_3c459229-1d0a-457c-b7b1-becb86535ac7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Brood and Barley",
      "poi_type": "Restaurants",
      "poi_address": "411 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Casual gastropub specializing in sliders, burgers and steaks, plus beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-4d7d-75ab-9b77-8403e475b35e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-4d7d-75ab-9b77-8403e475b35e",
        "storage_key": "property/6737460151192621/019e1e03-4d7d-75ab-9b77-8403e475b35e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.broodandbarley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11202043947735015600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brood-and-barley",
      "poi_latitude": "34.7575145",
      "poi_longitude": "-92.2678324",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-400-8967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e0b-70ac-b546-ae673ed41882",
        "storage_key": "property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_-HGX690ocRsGAPl56ndZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gastropub"
    },
    {
      "id": "custom_26b15345-2754-4987-b31f-2159f191356a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Skinny J's Argenta",
      "poi_type": "Restaurants",
      "poi_address": "314a Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Casual restaurant offering comfort food with vegetarian options, plus a bar with a wide selection of beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-539b-74bc-b98d-99163cc7f86e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-539b-74bc-b98d-99163cc7f86e",
        "storage_key": "property/6737460151192621/019e1e03-539b-74bc-b98d-99163cc7f86e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://skinnyjs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17305208340775788841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skinny-js-argenta",
      "poi_latitude": "34.7567056",
      "poi_longitude": "-92.2676099",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-916-2658",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1c-714f-a791-1d305d425d74",
        "storage_key": "property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ84NY4G80ocRKWERjExzKPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2fb79f80-0acb-4d97-b880-63d3e7131d1c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Four Quarter Bar",
      "poi_type": "Restaurants",
      "poi_address": "415 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Pub fare like house-smoked pork served in chill digs with a full bar, live weekend music & a patio.",
      "poi_long_description": "Pub fare like house-smoked pork served in chill digs with a full bar, live weekend music & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-535b-77ab-a448-61f38d0b3262.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-535b-77ab-a448-61f38d0b3262",
        "storage_key": "property/6737460151192621/019e1e03-535b-77ab-a448-61f38d0b3262.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fourquarterbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9814059172389972854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "four-quarter-bar",
      "poi_latitude": "34.75767390000001",
      "poi_longitude": "-92.2679825",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-313-4704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e0b-70ac-b546-ae673ed41882",
        "storage_key": "property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-V54oO80ocRduv39tGKMog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_fb3181e6-8a72-4911-8178-23bb88714b86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Reno's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "312 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Neighborhood hangout offering sandwiches, gyros & pizzas, plus a full bar & live music on weekends.",
      "poi_long_description": "Neighborhood hangout offering sandwiches, gyros & pizzas, plus a full bar & live music on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-4d7e-7369-9a7b-f09604069380.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-4d7e-7369-9a7b-f09604069380",
        "storage_key": "property/6737460151192621/019e1e03-4d7e-7369-9a7b-f09604069380.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://renoscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14858137782810764992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renos-cafe",
      "poi_latitude": "34.7566161",
      "poi_longitude": "-92.2675925",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-376-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e0b-70ac-b546-ae673ed41882",
        "storage_key": "property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT31EZYG80ocRwOY-eJe1Ms4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_d0ee2b59-803e-4fff-87f3-c975dae15b53",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Crush Wine Bar",
      "poi_type": "Restaurants",
      "poi_address": "318 N Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Chill spot boasting a selection of wine, cheese and meat platters served by friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-4c99-70a9-bebe-a66f4cb29cc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-4c99-70a9-bebe-a66f4cb29cc9",
        "storage_key": "property/6737460151192621/019e1e03-4c99-70a9-bebe-a66f4cb29cc9.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.facebook.com/pages/Crush-Wine-Bar/166280556769443",
      "poi_directions_map_url": "https://maps.google.com/?cid=201777118372375007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crush-wine-bar",
      "poi_latitude": "34.756795",
      "poi_longitude": "-92.2675973",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-374-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e0b-70ac-b546-ae673ed41882",
        "storage_key": "property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5eAcHy70ocR3yljWDjbzAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_d14dfd37-fb23-4ca3-90b8-ce20fb1d18c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Santo Coyote | Mexican Food & Tequila Bar",
      "poi_type": "Restaurants",
      "poi_address": "2513 McCain Blvd # 1, North Little Rock, AR 72116, USA",
      "poi_short_description": "Colorful cantina doling out fajitas & other Mexican classics in contemporary surrounds.",
      "poi_long_description": "Colorful cantina doling out fajitas & other Mexican classics in contemporary surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-5351-7464-bdc9-1acf4b942cc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-5351-7464-bdc9-1acf4b942cc4",
        "storage_key": "property/6737460151192621/019e1e03-5351-7464-bdc9-1acf4b942cc4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.santo-coyote.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16677777863328402377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santo-coyote--mexican-food--tequila-bar",
      "poi_latitude": "34.7966009",
      "poi_longitude": "-92.2358132",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-753-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1c-714f-a791-1d305d425d74",
        "storage_key": "property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ZMm3jK80ocRyQuQoppec-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c5275f55-6b6d-4c5b-82c3-fe8644b6298a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Las Palmas",
      "poi_type": "Restaurants",
      "poi_address": "4154 McCain Blvd, North Little Rock, AR 72117, USA",
      "poi_short_description": "Unfussy local Mexican chain serving burritos, fajitas & seafood, plus margaritas & beer.",
      "poi_long_description": "Unfussy local Mexican chain serving burritos, fajitas & seafood, plus margaritas & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-572b-739f-abee-562d5bc7ad9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-572b-739f-abee-562d5bc7ad9c",
        "storage_key": "property/6737460151192621/019e1e03-572b-739f-abee-562d5bc7ad9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.laspalmas-arkansas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8108357901850530364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "las-palmas",
      "poi_latitude": "34.7861222",
      "poi_longitude": "-92.2238218",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-945-8010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1c-714f-a791-1d305d425d74",
        "storage_key": "property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJteuvNCi80ocRPFKIQ42shnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_a8280d17-231c-431c-8439-69ec4ebd83a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Tacos El Zacatecas",
      "poi_type": "Restaurants",
      "poi_address": "4625 Camp Robinson Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-5301-776d-94e0-180b6ca0bef3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-5301-776d-94e0-180b6ca0bef3",
        "storage_key": "property/6737460151192621/019e1e03-5301-776d-94e0-180b6ca0bef3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15014080138777614834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacos-el-zacatecas",
      "poi_latitude": "34.7972994",
      "poi_longitude": "-92.2703042",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-599-8027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1c-714f-a791-1d305d425d74",
        "storage_key": "property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrUbyNZO90ocR8lkWlVa6XNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b7ba2a61-eb6c-490b-809e-29522050147c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Larry's Pizza of NLR",
      "poi_type": "Restaurants",
      "poi_address": "5933 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "No-frills local chain restaurant offering lots of specialty pizzas, plus sandwiches & salads.",
      "poi_long_description": "No-frills local chain restaurant offering lots of specialty pizzas, plus sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-4d20-7609-844e-7bc7309764b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-4d20-7609-844e-7bc7309764b0",
        "storage_key": "property/6737460151192621/019e1e03-4d20-7609-844e-7bc7309764b0.webp",
        "width": 1280,
        "height": 632
      },
      "poi_business_url": "http://larryspizzaofarkansas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17801530169184507833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "larrys-pizza-of-nlr",
      "poi_latitude": "34.8098588",
      "poi_longitude": "-92.2483805",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-812-5353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1c-714f-a791-1d305d425d74",
        "storage_key": "property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZ3GXbi90ocRuVekUF-9C_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_48494e97-a678-4876-aa5b-2fc426c843df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Red Lobster",
      "poi_type": "Restaurants",
      "poi_address": "3707 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Casual chain for lobster, steak and seafood, plus beer, wine, and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-5816-7068-8363-94badb6bdf7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-5816-7068-8363-94badb6bdf7d",
        "storage_key": "property/6737460151192621/019e1e03-5816-7068-8363-94badb6bdf7d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.redlobster.com/seafood-restaurants/locations/ar/north-little-rock/3707-mccain-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=16069348512379039193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-lobster",
      "poi_latitude": "34.792929",
      "poi_longitude": "-92.230131",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-753-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1c-714f-a791-1d305d425d74",
        "storage_key": "property/6737460151192621/019e1e01-4e1c-714f-a791-1d305d425d74.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKY1nLCy80ocR2e1NPFXLAd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_88a3e820-c0ba-47a7-a0bf-7ff9698773b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "2812 Lakewood Village Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-592c-738f-8519-5a48f19daea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-592c-738f-8519-5a48f19daea4",
        "storage_key": "property/6737460151192621/019e1e03-592c-738f-8519-5a48f19daea4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ar/north-little-rock/2812-lakewood-village-drive?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=606204&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=12456298066679362108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "34.79447",
      "poi_longitude": "-92.232596",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-771-0168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-a202-73be-a579-bb0f8abeb0c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e03-a202-73be-a579-bb0f8abeb0c0",
        "storage_key": "property/6737460151192621/019e1e03-a202-73be-a579-bb0f8abeb0c0.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJj7oiIy280ocRPPLOaBip3aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_585b7792-9f4c-45ae-9a24-beffc92fa1da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Edwards Cash Saver",
      "poi_type": "Shopping & Retail",
      "poi_address": "Northgate Plaza, Levy Shopping Center, 3801 Camp Robinson Rd #3442, North Little Rock, AR 72118, USA",
      "poi_short_description": "Grocery store with good prices, fresh produce, and a selection of hot foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-5990-77f8-9664-787e873fc1c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-5990-77f8-9664-787e873fc1c2",
        "storage_key": "property/6737460151192621/019e1e03-5990-77f8-9664-787e873fc1c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edwardscashsaver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15299932246299274901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edwards-cash-saver",
      "poi_latitude": "34.7908333",
      "poi_longitude": "-92.2763889",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-404-6320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e49-73df-96ca-19988a15c457.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e49-73df-96ca-19988a15c457",
        "storage_key": "property/6737460151192621/019e1e01-4e49-73df-96ca-19988a15c457.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo-JHDOS80ocRlW42xFBHVNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b70c9eed-16f6-4b47-a0d4-085c9338eb3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "3801 Camp Robinson Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-599f-7161-84f4-8349d8a2e803.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-599f-7161-84f4-8349d8a2e803",
        "storage_key": "property/6737460151192621/019e1e03-599f-7161-84f4-8349d8a2e803.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/ar/north-little-rock/3801-camp-robinson-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12635926455762507968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "34.7908107",
      "poi_longitude": "-92.2770832",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-243-0765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-32fc220892ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-32fc220892ef",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-32fc220892ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo-JHDOS80ocRwFiv2ynUW68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_be726873-bf92-4efe-84d3-90eec74a7126",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "4204 Camp Robinson Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-5cfe-702b-96ca-d400d4fb2001.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-5cfe-702b-96ca-d400d4fb2001",
        "storage_key": "property/6737460151192621/019e1e03-5cfe-702b-96ca-d400d4fb2001.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "https://locations.familydollar.com/ar/n-little-rock/4204-camp-robinson-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10759897105340836861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "34.7935244",
      "poi_longitude": "-92.2714821",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-902-4021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-32fc220892ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-32fc220892ef",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-32fc220892ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKay4z_y80ocR_SuYr2jVUpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_78a2658b-59c1-4fee-aca9-5d5ea174c35f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "4401 Camp Robinson Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Chain grocery outpost with prepared foods, organic products, and household items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-1402-7088-97a2-d7b919e08f02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-1402-7088-97a2-d7b919e08f02",
        "storage_key": "property/6737460151192621/019e1e01-1402-7088-97a2-d7b919e08f02.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ar/north-little-rock/camp-robinson/025/00638?cid=loc_02500638_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9921715092998316223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "34.7950171",
      "poi_longitude": "-92.2729093",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-758-6858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e49-73df-96ca-19988a15c457.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e49-73df-96ca-19988a15c457",
        "storage_key": "property/6737460151192621/019e1e01-4e49-73df-96ca-19988a15c457.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8ZA0-K80ocRv-DLQE8DsYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_797775e7-da2c-4da8-b8a2-4ec144cd27e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "4523 Camp Robinson Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-5d8e-7316-bd19-2916e655e0be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-5d8e-7316-bd19-2916e655e0be",
        "storage_key": "property/6737460151192621/019e1e03-5d8e-7316-bd19-2916e655e0be.webp",
        "width": 1280,
        "height": 806
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ar/north-little-rock/13767",
      "poi_directions_map_url": "https://maps.google.com/?cid=5780788234275051994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "34.7963558",
      "poi_longitude": "-92.2713387",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-500-1135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-32fc220892ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-32fc220892ef",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-32fc220892ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmRGgb_280ocR2tm4aUV8OVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_3a5949fc-53d7-4741-9644-809118f18fef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Shell",
      "poi_type": "Shopping & Retail",
      "poi_address": "4622 Camp Robinson Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Gas station in the Shell chain featuring a convenience store, an ATM, and restrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-6602-70eb-867d-32b4ba6a55ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-6602-70eb-867d-32b4ba6a55ac",
        "storage_key": "property/6737460151192621/019e1e03-6602-70eb-867d-32b4ba6a55ac.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://find.shell.com/us/fuel/10010533-4622-camp-robinson-rd/en_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=456244858638236018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shell",
      "poi_latitude": "34.7972885",
      "poi_longitude": "-92.2696617",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-753-5221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-a1f3-759d-9f59-59ef05a3a1dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e03-a1f3-759d-9f59-59ef05a3a1dc",
        "storage_key": "property/6737460151192621/019e1e03-a1f3-759d-9f59-59ef05a3a1dc.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJqSo6dgK90ocRcvm6GUjoVAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_fa992018-65d8-4842-8a97-b3696ea477b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "4823 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-6534-7074-b400-e307fd49041b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-6534-7074-b400-e307fd49041b",
        "storage_key": "property/6737460151192621/019e1e03-6534-7074-b400-e307fd49041b.webp",
        "width": 1280,
        "height": 868
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-4823+john+f+kennedy+blvd-north+little+rock-ar-72116/id=3416",
      "poi_directions_map_url": "https://maps.google.com/?cid=16809595157491161868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.79976360000001",
      "poi_longitude": "-92.25572710000002",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-771-1971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2Xt_ay90ocRDBtjFLytR-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_8710e5e9-9b6a-468f-acad-e03f4c44f423",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "goodstop by Casey’s",
      "poi_type": "Shopping & Retail",
      "poi_address": "3401 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_long_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-5f20-754f-8613-d2957ee6ca5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-5f20-754f-8613-d2957ee6ca5a",
        "storage_key": "property/6737460151192621/019e1e03-5f20-754f-8613-d2957ee6ca5a.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.caseys.com/general-store/ar-northlittlerock/3401-john-f-kennedy-blvd/4253?utm_medium=organic&utm_source=google&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=14968629905655937971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodstop-by-caseys",
      "poi_latitude": "34.78632",
      "poi_longitude": "-92.26076",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-753-2237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-a1f3-759d-9f59-59ef05a3a1dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e03-a1f3-759d-9f59-59ef05a3a1dc",
        "storage_key": "property/6737460151192621/019e1e03-a1f3-759d-9f59-59ef05a3a1dc.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJPfPD6Eu90ocRszvpjJdBu88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_32063eac-9d3f-4d4f-9432-4b1031e5bd46",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4000 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-5f61-75ce-998c-b1da8581ed5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-5f61-75ce-998c-b1da8581ed5b",
        "storage_key": "property/6737460151192621/019e1e03-5f61-75ce-998c-b1da8581ed5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/little-rock-north/162",
      "poi_directions_map_url": "https://maps.google.com/?cid=5304223806694593745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "34.7880996",
      "poi_longitude": "-92.2290477",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-771-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-32fc220892ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-32fc220892ef",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-32fc220892ef.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBZfj0Si80ocR0ZQz_3JjnEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d54e8867-8ae7-4e33-bba3-6346796c701c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Maverik",
      "poi_type": "Shopping & Retail",
      "poi_address": "5216 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Gas station & convenience store chain offering hot & cold snacks, plus coffees & sodas.",
      "poi_long_description": "Gas station & convenience store chain offering hot & cold snacks, plus coffees & sodas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-5f5e-7478-b935-6ed22af372e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-5f5e-7478-b935-6ed22af372e1",
        "storage_key": "property/6737460151192621/019e1e03-5f5e-7478-b935-6ed22af372e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.maverik.com/ar/north-little-rock/5216-jfk-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=10884108417569703044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maverik",
      "poi_latitude": "34.8028355",
      "poi_longitude": "-92.2531742",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-975-1603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-a1f3-759d-9f59-59ef05a3a1dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e03-a1f3-759d-9f59-59ef05a3a1dc",
        "storage_key": "property/6737460151192621/019e1e03-a1f3-759d-9f59-59ef05a3a1dc.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVo8_K290ocRhMQUdvAeDJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_257df969-a626-4a2c-972b-e924d6701937",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Oak Grove Elementary School",
      "poi_type": "Education",
      "poi_address": "5703 Oak Grove Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://oakgrove.pcssd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10592898423203367274&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-grove-elementary-school",
      "poi_latitude": "34.8412004",
      "poi_longitude": "-92.3326229",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-851-5370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPVr5GXiY0ocRagnVCP6IAZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_04b75052-a524-4b07-aa60-3d62912e12e3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Crystal Hill Elementary School",
      "poi_type": "Education",
      "poi_address": "5001 Northshore Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ches.pcssd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11405248024831450248&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crystal-hill-elementary-school",
      "poi_latitude": "34.8035481",
      "poi_longitude": "-92.352693",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-791-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy8chmlGi0ocRiNxNp6aUR54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fb70135c-8fe9-4911-b7b9-121ec2083097",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "LISA Academy North Middle-High",
      "poi_type": "Education",
      "poi_address": "1 Lisa Academy Way, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-655c-74c2-96e3-ff08f14d4cf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-655c-74c2-96e3-ff08f14d4cf3",
        "storage_key": "property/6737460151192621/019e1e03-655c-74c2-96e3-ff08f14d4cf3.webp",
        "width": 1280,
        "height": 923
      },
      "poi_business_url": "https://northmhs.lisaacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17062120022007953039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lisa-academy-north-middle-high",
      "poi_latitude": "34.7997349",
      "poi_longitude": "-92.2128858",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-945-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq0RlKPS_0ocRjzbd0sLTyOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d202abaf-f378-4819-984c-307a73f1ead5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Central Arkansas Christian Schools",
      "poi_type": "Education",
      "poi_address": "1 Windsong Dr, North Little Rock, AR 72113, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-65bf-70a8-bbc0-a40646220aed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-65bf-70a8-bbc0-a40646220aed",
        "storage_key": "property/6737460151192621/019e1e03-65bf-70a8-bbc0-a40646220aed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cacmustangs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8511481949218560822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-arkansas-christian-schools",
      "poi_latitude": "34.8155479",
      "poi_longitude": "-92.3550643",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-758-3160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTSIdPl2i0ocRNltSr7zbHnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b8b11111-042e-43e2-974a-3b4b324e7675",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "University of Arkansas – Pulaski Technical College",
      "poi_type": "Education",
      "poi_address": "3000 W Scenic Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-1dc4-76d8-abcc-4c23f3d9577c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-1dc4-76d8-abcc-4c23f3d9577c",
        "storage_key": "property/6737460151192621/019e1e01-1dc4-76d8-abcc-4c23f3d9577c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.uaptc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3922972585545535160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas--pulaski-technical-college",
      "poi_latitude": "34.78212980000001",
      "poi_longitude": "-92.2993636",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-812-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ_E4js280ocRuI4JIcgycTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_106a074d-c618-469f-bf51-ddcc37a91c8e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "North Little Rock High School",
      "poi_type": "Education",
      "poi_address": "201 W 22nd St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-6b16-71dc-a13a-83504d5635c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-6b16-71dc-a13a-83504d5635c5",
        "storage_key": "property/6737460151192621/019e1e03-6b16-71dc-a13a-83504d5635c5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.nlrsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8188116334975508691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-high-school",
      "poi_latitude": "34.776321",
      "poi_longitude": "-92.269072",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-771-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdaP0tvS80ocR0-DJlWwIonE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_75e42d75-ab91-4da9-bcdc-b7ff405f8824",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Bright Beginning Child Care Center",
      "poi_type": "Education",
      "poi_address": "200 W 20th St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-6a68-701f-8670-a641a70a53f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-6a68-701f-8670-a641a70a53f6",
        "storage_key": "property/6737460151192621/019e1e03-6a68-701f-8670-a641a70a53f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://brightenlife.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6467580498750725529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-beginning-child-care-center",
      "poi_latitude": "34.7728162",
      "poi_longitude": "-92.2688051",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-771-0114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcVe_YwG90ocRmd1HaDJ2wVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_c9f67a22-d0ee-48c1-a0bb-4b7ef5fa201f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Mama Myrtles Daycare",
      "poi_type": "Education",
      "poi_address": "2501 N Poplar St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9210760239395903139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mama-myrtles-daycare",
      "poi_latitude": "34.7783671",
      "poi_longitude": "-92.2655143",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-353-0157",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0cFYVPS80ocRoxZ8FKMx038",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_b085e3d2-2f66-4a2e-be79-b885a1c3d6cd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Levy Christian Kindergarten",
      "poi_type": "Education",
      "poi_address": "5124 Camp Robinson Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1809833055916054922&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "levy-christian-kindergarten",
      "poi_latitude": "34.8023677",
      "poi_longitude": "-92.2663097",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-758-5466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqVkTNAG90ocRitmiUJPRHRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_4a4387c9-5307-411e-86dc-5a480237ad68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Incredible Kidz Daycare",
      "poi_type": "Education",
      "poi_address": "320 N Locust St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15953852344810646991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "incredible-kidz-daycare",
      "poi_latitude": "34.7566643",
      "poi_longitude": "-92.2613852",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-508-5452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAbyDRX680ocRz614My54Z90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_83dcd9f7-dfc0-4b55-a8a2-62019b2d82a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Argenta Plaza",
      "poi_type": "Entertainment",
      "poi_address": "510 N Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Space for various events, along with an LED-lit plaza featuring a splash pad and swing benches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-6e44-74fa-a374-d4c81ef4a884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-6e44-74fa-a374-d4c81ef4a884",
        "storage_key": "property/6737460151192621/019e1e03-6e44-74fa-a374-d4c81ef4a884.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.northlittlerock.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2843491569430379576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "argenta-plaza",
      "poi_latitude": "34.7585258",
      "poi_longitude": "-92.2674137",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-758-1424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJId1SYYO90ocRODy3VYQcdic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_fc3f97ed-e110-40cd-9f01-00232079f98f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Argenta Contemporary Theatre",
      "poi_type": "Entertainment",
      "poi_address": "405 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Nonprofit organization presenting a variety of performing arts productions for all ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-6a61-71cd-8097-502b84dcddb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-6a61-71cd-8097-502b84dcddb6",
        "storage_key": "property/6737460151192621/019e1e03-6a61-71cd-8097-502b84dcddb6.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://argentacontemporarytheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5638920590178178111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "argenta-contemporary-theatre",
      "poi_latitude": "34.7573812",
      "poi_longitude": "-92.2679905",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-353-1443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWbK4YO80ocRP9Q0hmZ4QU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_483cc0a8-0c03-4999-8652-a792f12670e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Arkansas Inland Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "120 Riverfront Park Dr, North Little Rock, AR 72114, USA",
      "poi_short_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_long_description": "Exhibits on naval history & Arkansas aquaculture, plus tours of USS Razorback, a WWII-era submarine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-6d6b-7618-a314-e0e0dd51be8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-6d6b-7618-a314-e0e0dd51be8d",
        "storage_key": "property/6737460151192621/019e1e03-6d6b-7618-a314-e0e0dd51be8d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/arkansas-inland-maritime-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9401581648013172689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-inland-maritime-museum",
      "poi_latitude": "34.7522251",
      "poi_longitude": "-92.2669543",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-371-8320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e6f-732b-8460-4d7e99aca0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e6f-732b-8460-4d7e99aca0d0",
        "storage_key": "property/6737460151192621/019e1e01-4e6f-732b-8460-4d7e99aca0d0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJHa_JEH670ocR0R-oeLIgeYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_419619ca-a818-477d-8cc5-0e3c1bba6c85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Dickey-Stephens Park",
      "poi_type": "Entertainment",
      "poi_address": "400 W Broadway St, North Little Rock, AR 72114, USA",
      "poi_short_description": "Relaxed ballpark for the Arkansas Travelers minor-league team, also hosting event nights.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-7048-7369-9d46-c787b37fe1fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-7048-7369-9d46-c787b37fe1fd",
        "storage_key": "property/6737460151192621/019e1e03-7048-7369-9d46-c787b37fe1fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milb.com/arkansas",
      "poi_directions_map_url": "https://maps.google.com/?cid=251025925877761128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dickey-stephens-park",
      "poi_latitude": "34.7554878",
      "poi_longitude": "-92.2725898",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-664-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUkZyJy80ocRaIRb5b_SewM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_6b098568-3eb3-4227-8515-733dbee3dbdc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Simmons Bank Arena",
      "poi_type": "Entertainment",
      "poi_address": "1 Simmons Bank Arena Dr, North Little Rock, AR 72114, USA",
      "poi_short_description": "Sports & entertainment venue with 18,000 seats hosting basketball, trade shows & major musical acts.",
      "poi_long_description": "Sports & entertainment venue with 18,000 seats hosting basketball, trade shows & major musical acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-2016-72c4-a6e2-e187456005f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-2016-72c4-a6e2-e187456005f5",
        "storage_key": "property/6737460151192621/019e1e01-2016-72c4-a6e2-e187456005f5.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://simmonsbankarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13831376352313287939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simmons-bank-arena",
      "poi_latitude": "34.7550895",
      "poi_longitude": "-92.2643235",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-340-5660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeTmHEoC80ocRAyVfuoLr8r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_ebed6955-00c4-461d-ae69-4ed7ec57065f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "The Old Mill",
      "poi_type": "Entertainment",
      "poi_address": "3800 Lakeshore Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Quaint 1880's-style water mill with rustic outdoor sculptures, located in T.R. Pugh Memorial Park.",
      "poi_long_description": "Quaint 1880's-style water mill with rustic outdoor sculptures, located in T.R. Pugh Memorial Park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-2127-76e9-9f09-8a61103baac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-2127-76e9-9f09-8a61103baac1",
        "storage_key": "property/6737460151192621/019e1e01-2127-76e9-9f09-8a61103baac1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/old-mill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13753738084307160303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-old-mill",
      "poi_latitude": "34.7913123",
      "poi_longitude": "-92.249526",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Xsnok680ocR78zj0OoX374",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_1d50be80-10a6-4289-95ee-d547c840d668",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Ron Robinson Theater -- Central Arkansas Library System",
      "poi_type": "Entertainment",
      "poi_address": "Library Square, 100 River Market Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Theater (part of the Central Arkansas Library System) equipped for films, concerts, plays and lectures, among other performances.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-72e8-773f-bf43-6fc7937aa9bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-72e8-773f-bf43-6fc7937aa9bd",
        "storage_key": "property/6737460151192621/019e1e03-72e8-773f-bf43-6fc7937aa9bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ronrobinsontheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9620992703836030317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ron-robinson-theater----central-arkansas-library-system",
      "poi_latitude": "34.7472238",
      "poi_longitude": "-92.2659196",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-320-5715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyfNLKHm70ocRbYXF0uOhhIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_d8d2abf8-3870-4b44-a2af-06fccc341be2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "William J. Clinton Library and Museum",
      "poi_type": "Entertainment",
      "poi_address": "1200 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_long_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-1da7-71fa-ab0e-01699c31c93a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-1da7-71fa-ab0e-01699c31c93a",
        "storage_key": "property/6737460151192621/019e1e01-1da7-71fa-ab0e-01699c31c93a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.clintonpresidentialcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8035004359637958132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-j-clinton-library-and-museum",
      "poi_latitude": "34.7464097",
      "poi_longitude": "-92.2583824",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-370-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e6f-732b-8460-4d7e99aca0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e6f-732b-8460-4d7e99aca0d0",
        "storage_key": "property/6737460151192621/019e1e01-4e6f-732b-8460-4d7e99aca0d0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWsmz4O70ocR9H3v0OQRgm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_f6a59237-eda4-4629-9165-e75b7228e766",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Revolution Music Room (The Rev Room)",
      "poi_type": "Entertainment",
      "poi_address": "300 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Locally owned venue hosting concerts by diverse performers in an intimate, casual setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-7405-751e-9ec4-c9bf4eb84332.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-7405-751e-9ec4-c9bf4eb84332",
        "storage_key": "property/6737460151192621/019e1e03-7405-751e-9ec4-c9bf4eb84332.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.revroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10306964832580352669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "revolution-music-room-the-rev-room",
      "poi_latitude": "34.7477915",
      "poi_longitude": "-92.2675003",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-823-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZZLrH670ocRnTplFuixCY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "custom_08b70a81-0c07-4071-b620-bffdbfa67ed5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "White Water Tavern",
      "poi_type": "Entertainment",
      "poi_address": "2500 W 7th St, Little Rock, AR 72205, USA",
      "poi_short_description": "Cabin-like joint with funky decor offering up beer & bar grub, plus live music performances.",
      "poi_long_description": "Cabin-like joint with funky decor offering up beer & bar grub, plus live music performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-747b-745b-b1d5-0fa18e7a86de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-747b-745b-b1d5-0fa18e7a86de",
        "storage_key": "property/6737460151192621/019e1e03-747b-745b-b1d5-0fa18e7a86de.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://whitewatertavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14816663596357101888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-water-tavern",
      "poi_latitude": "34.745416",
      "poi_longitude": "-92.301265",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-375-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e0b-70ac-b546-ae673ed41882",
        "storage_key": "property/6737460151192621/019e1e01-4e0b-70ac-b546-ae673ed41882.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3BlFVO70ocRQKlT8Qldn80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_199d6cb9-e8af-40f5-a572-fc425d884e14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Baptist Health Medical Center-North Little Rock",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 Springhill Dr, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-722c-734c-a714-085b4c50830c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-722c-734c-a714-085b4c50830c",
        "storage_key": "property/6737460151192621/019e1e03-722c-734c-a714-085b4c50830c.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.baptist-health.com/find-care/location/baptist-health-medical-center-north-little-rock/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12673750733774113147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-medical-center-north-little-rock",
      "poi_latitude": "34.7835092",
      "poi_longitude": "-92.2224382",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-202-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e69-775f-90f1-d2ac408658ab",
        "storage_key": "property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23mhdJ2-0ocRe8lz2iQ14q8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_066a6fe9-45da-4ba2-aca2-3ca2d89755e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "3470 Landers Rd, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-772e-7389-9931-e60ea04b78cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-772e-7389-9931-e60ea04b78cb",
        "storage_key": "property/6737460151192621/019e1e03-772e-7389-9931-e60ea04b78cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=16932988419623418443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "34.7857082",
      "poi_longitude": "-92.227934",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-945-0661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo4Codia80ocRS_p0uUAP_uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_1f2cc691-afa7-49c4-b080-b4cca9b926fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Cornerstone Pharmacy Lakewood",
      "poi_type": "Health and Wellness",
      "poi_address": "2609 McCain Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-7539-77b9-b392-28af5117751c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-7539-77b9-b392-28af5117751c",
        "storage_key": "property/6737460151192621/019e1e03-7539-77b9-b392-28af5117751c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://cornerstonepharmacy.com/cornerstone-pharmacy-locations/cornerstone-pharmacy-lakewood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12869632871358594481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cornerstone-pharmacy-lakewood",
      "poi_latitude": "34.7964958",
      "poi_longitude": "-92.2346119",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-353-1984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-a1f3-759d-9f59-5ea4d853dea8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e03-a1f3-759d-9f59-5ea4d853dea8",
        "storage_key": "property/6737460151192621/019e1e03-a1f3-759d-9f59-5ea4d853dea8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSbh5TK80ocRsf0EB-kemrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ac389d90-1451-486d-8c41-5f2bd95c3ac7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Camp Robinson Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-780b-704d-b3ed-70b2ee40107d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-780b-704d-b3ed-70b2ee40107d",
        "storage_key": "property/6737460151192621/019e1e03-780b-704d-b3ed-70b2ee40107d.webp",
        "width": 1044,
        "height": 587
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/025/00638?cid=loc_02500638P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9239262271162646209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "34.7951052",
      "poi_longitude": "-92.2729415",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-758-6360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-a1f3-759d-9f59-5ea4d853dea8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e03-a1f3-759d-9f59-5ea4d853dea8",
        "storage_key": "property/6737460151192621/019e1e03-a1f3-759d-9f59-5ea4d853dea8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8ZA0-K80ocRwX5RexV0OIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3767d021-b7af-4a3e-98f6-d40c02a2ce47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4450 E McCain Blvd, North Little Rock, AR 72117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-77a6-7753-867a-5a2dd10b9137.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-77a6-7753-867a-5a2dd10b9137",
        "storage_key": "property/6737460151192621/019e1e03-77a6-7753-867a-5a2dd10b9137.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1105-north-little-rock-ar/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16114164768355161454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "34.7864674",
      "poi_longitude": "-92.2144437",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-945-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-a1f3-759d-9f59-5ea4d853dea8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e03-a1f3-759d-9f59-5ea4d853dea8",
        "storage_key": "property/6737460151192621/019e1e03-a1f3-759d-9f59-5ea4d853dea8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcxRChYS-0ocRbpXs9XoDod8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_254becc4-8e63-4d1c-a68f-8b854f082c5d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4617 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Chain gym with tanning beds and hydromassage in North Park Mall.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-226a-7169-a739-a06acedc8139.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-226a-7169-a739-a06acedc8139",
        "storage_key": "property/6737460151192621/019e1e01-226a-7169-a739-a06acedc8139.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/north-little-rock-ar?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7560349064309511589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.7976804",
      "poi_longitude": "-92.2567809",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-377-9535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSttMYK90ocRpRUg5GrB62g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_49055c41-e008-491d-8c8a-3871b8ad555a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4832 N Hills Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "Chain fitness studio offering group classes that combine cardio and strength training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-84f3-748f-8105-eb32bc569db2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-84f3-748f-8105-eb32bc569db2",
        "storage_key": "property/6737460151192621/019e1e03-84f3-748f-8105-eb32bc569db2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/north-little-rock-arkansas-0997?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=17246918376891246391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "34.7986594",
      "poi_longitude": "-92.2367183",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-404-7505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJASPNtzO90ocRN2fCvOJcWe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_409d66b7-9a65-44a8-a426-bf43a5150878",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5923 John F Kennedy Blvd, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-7a0b-7458-8069-9c71ad53e2ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-7a0b-7458-8069-9c71ad53e2ea",
        "storage_key": "property/6737460151192621/019e1e03-7a0b-7458-8069-9c71ad53e2ea.webp",
        "width": 512,
        "height": 289
      },
      "poi_business_url": "https://www.anytimefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11315798387228146804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "34.8095145",
      "poi_longitude": "-92.2487705",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-771-0908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVN2HLq90ocRdPyr9K3KCZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8d5b0a49-b3dc-4ede-a866-c8a39a4e91f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "North Little Rock Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3804 McCain Park Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "Spacious exercise facility featuring an indoor track, indoor lap pool and outdoor recreation pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-79b9-76b9-ba14-b9afd07ec527.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-79b9-76b9-ba14-b9afd07ec527",
        "storage_key": "property/6737460151192621/019e1e03-79b9-76b9-ba14-b9afd07ec527.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://www.nlrac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2182274469150791261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-athletic-club",
      "poi_latitude": "34.7943015",
      "poi_longitude": "-92.2249774",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-812-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ3K8aSq80ocRXRYjSBH_SB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_f803de4d-18fa-4e85-b2d8-3b1f56a35100",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - North Little Rock",
      "poi_type": "Health and Wellness",
      "poi_address": "2939 Lakewood Village Dr, North Little Rock, AR 72116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-7b40-745c-ae88-153a2e41cb41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-7b40-745c-ae88-153a2e41cb41",
        "storage_key": "property/6737460151192621/019e1e03-7b40-745c-ae88-153a2e41cb41.webp",
        "width": 250,
        "height": 250
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/north-little-rock.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9804404571120485146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genesis-health-clubs---north-little-rock",
      "poi_latitude": "34.7942016",
      "poi_longitude": "-92.2305267",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-708-0878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZPLZC690ocRGkPa7wI-EIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_2092fcc4-fd7e-483e-91b1-06adb1b7e229",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Riverview Skateboard Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2801 River Rd, North Little Rock, AR 72114, USA",
      "poi_short_description": "Recreational venue with a skate park, a playground, and a bike/walking trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-80ba-722b-8993-600582540e57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-80ba-722b-8993-600582540e57",
        "storage_key": "property/6737460151192621/019e1e03-80ba-722b-8993-600582540e57.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/riverview-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11151943499546355846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-skateboard-park",
      "poi_latitude": "34.76926340000001",
      "poi_longitude": "-92.2967257",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVliDSy90ocRhuiv_Yapw5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "skateboard_park"
    },
    {
      "id": "custom_c3684b76-829c-46d0-b182-fcc2415c0649",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Big Rock Quarry",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bay Oaks Dr, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-82a3-7468-9d8a-56591422970f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-82a3-7468-9d8a-56591422970f",
        "storage_key": "property/6737460151192621/019e1e03-82a3-7468-9d8a-56591422970f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://nlrpr.org/cms/one.aspx?portalId=96195&pageId=200421",
      "poi_directions_map_url": "https://maps.google.com/?cid=8983319870280631652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-rock-quarry",
      "poi_latitude": "34.7800996",
      "poi_longitude": "-92.3045839",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e6d-74d4-b5c5-91aace8d89b6",
        "storage_key": "property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKxscPIej0ocRZAXJi9Mpq3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fa2fa867-ecb3-49a4-9d29-9466eb4b2587",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Big Dam Bridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4000 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_long_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-7ca8-7313-b603-51d6823e821c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-7ca8-7313-b603-51d6823e821c",
        "storage_key": "property/6737460151192621/019e1e03-7ca8-7313-b603-51d6823e821c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17869723390477343867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-dam-bridge",
      "poi_latitude": "34.7925668",
      "poi_longitude": "-92.3584127",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7GbOUyi0ocRexzk674C_vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bridge"
    },
    {
      "id": "custom_06a87f14-371c-4860-940c-48d11847b929",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Cook's Landing Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4100 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "Park offering trails for walking, biking, and running, plus fishing and a boat ramp.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-8111-71ce-a242-d4bc03cd7b53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-8111-71ce-a242-d4bc03cd7b53",
        "storage_key": "property/6737460151192621/019e1e03-8111-71ce-a242-d4bc03cd7b53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.littlerock.gov/residents/parks-and-recreation/city-park-information/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11341903977596059546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooks-landing-park",
      "poi_latitude": "34.7966484",
      "poi_longitude": "-92.3564438",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-868-9477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e6d-74d4-b5c5-91aace8d89b6",
        "storage_key": "property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVX1tYUui0ocRmv8zXZOJZp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7d66cb7c-cc1b-4545-a63b-edab5468aaf1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "North Shore Riverwalk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "North Little Rock, AR 72114, USA",
      "poi_short_description": "City park featuring a riverwalk, trails, and a bridge, plus space for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-82fd-77e3-8df3-fd6e4b7e4d1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-82fd-77e3-8df3-fd6e4b7e4d1d",
        "storage_key": "property/6737460151192621/019e1e03-82fd-77e3-8df3-fd6e4b7e4d1d.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.nps.gov/places/north-shore-riverwalk-park.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=4170622964056154528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-shore-riverwalk-park",
      "poi_latitude": "34.7533362",
      "poi_longitude": "-92.2714573",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-758-1424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e6d-74d4-b5c5-91aace8d89b6",
        "storage_key": "property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw283eYK80ocRoGGnKH0H4Tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_ea95aa87-d1d2-43ba-ab81-0cfe6cd8458c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Burns Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "North Little Rock, AR 72118, USA",
      "poi_short_description": "Park offering ball fields, a 36-hole golf course, multi-use trails & fishing in the Arkansas River.",
      "poi_long_description": "Park offering ball fields, a 36-hole golf course, multi-use trails & fishing in the Arkansas River.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-8f8a-7221-8ffb-ef930f2133d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-8f8a-7221-8ffb-ef930f2133d0",
        "storage_key": "property/6737460151192621/019e1e03-8f8a-7221-8ffb-ef930f2133d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlr.ar.gov/departments/parks-and-recreation/parks/burns-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18303069099405761385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burns-park",
      "poi_latitude": "34.7976957",
      "poi_longitude": "-92.3099177",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-791-8538",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e6d-74d4-b5c5-91aace8d89b6",
        "storage_key": "property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzXtiMt-i0ocRaVuCQV-QAf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a9099d94-7a41-4c9f-9797-5bc070e6e089",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Murray Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5900 Rebsamen Park Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Outdoor venue offering a playground, volleyball court, and picnic and barbecue areas, plus boat ramps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-37c2-728f-ab9f-fa6c68b9475d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-37c2-728f-ab9f-fa6c68b9475d",
        "storage_key": "property/6737460151192621/019e1e01-37c2-728f-ab9f-fa6c68b9475d.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://www.littlerock.gov/56622",
      "poi_directions_map_url": "https://maps.google.com/?cid=13425768046898910529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "murray-park",
      "poi_latitude": "34.7856017",
      "poi_longitude": "-92.3351056",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e6d-74d4-b5c5-91aace8d89b6",
        "storage_key": "property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TWwWA-j0ocRQRUz6OfoUbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5169cf11-ab47-441a-81ad-26e3c6b8593c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Two Rivers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "RH6X+QC, 6900 Two Rivers Park Road, Little Rock, AR 72223, USA",
      "poi_short_description": "Natural area with bike paths, picnic tables, a playground, and trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-85ac-758d-8512-2b6164063305.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-85ac-758d-8512-2b6164063305",
        "storage_key": "property/6737460151192621/019e1e03-85ac-758d-8512-2b6164063305.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://pulaskicounty.net/two-rivers-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3852413415211130700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "two-rivers-park",
      "poi_latitude": "34.8114881",
      "poi_longitude": "-92.4017327",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e6d-74d4-b5c5-91aace8d89b6",
        "storage_key": "property/6737460151192621/019e1e01-4e6d-74d4-b5c5-91aace8d89b6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy13IPpah0ocRTN-bFZeFdjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_49fac026-854a-4e95-bd0c-65450b133717",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Wilmington Apartments",
      "poi_type": "Transportation & Transit",
      "poi_address": "617 Donovan Briley Blvd, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-8171-74ae-bf5e-67911aa551c9.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with a white fence and walkway.",
        "public_id": "019e1e01-8171-74ae-bf5e-67911aa551c9",
        "storage_key": "property/6737460151192621/019e1e01-8171-74ae-bf5e-67911aa551c9.webp",
        "width": 2400,
        "height": 1600
      },
      "poi_business_url": "https://www.liveatwilmington.com/?utm_knock=g",
      "poi_directions_map_url": "https://maps.google.com/?cid=3701132259215027048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilmington-apartments",
      "poi_latitude": "34.8150877",
      "poi_longitude": "-92.2742759",
      "poi_miles_from_property": "0.01",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-302-4032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt07YHRK90ocRaCtAKS4QXTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "custom_eb832b98-2235-424f-b4a3-aed82cab4eca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Rock Region METRO",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Maple St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-8954-763c-809d-3e266c0558b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-8954-763c-809d-3e266c0558b8",
        "storage_key": "property/6737460151192621/019e1e03-8954-763c-809d-3e266c0558b8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8174036123689371751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-region-metro",
      "poi_latitude": "34.7624459",
      "poi_longitude": "-92.2689822",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-375-6717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtavgzIW80ocRZ0i37YsCcHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_57a55eb3-7e56-4a59-97fd-e81304f2ba76",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "River Cities Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Capitol Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-8956-7549-992d-e5cf608be060.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-8956-7549-992d-e5cf608be060",
        "storage_key": "property/6737460151192621/019e1e03-8956-7549-992d-e5cf608be060.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3809342745980765106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-cities-travel-center",
      "poi_latitude": "34.7442945",
      "poi_longitude": "-92.2680391",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuazOJHq70ocRsgPlcQuB3TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_1c2e1f7c-fd31-4b4f-b2f3-beab83b79064",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "417-499 President Clinton Ave Parking",
      "poi_type": "Transportation & Transit",
      "poi_address": "417-499 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17842161563797608137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "417-499-president-clinton-ave-parking",
      "poi_latitude": "34.7472109",
      "poi_longitude": "-92.2659092",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-a1f7-735f-a442-c1c4625d15fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e03-a1f7-735f-a442-c1c4625d15fe",
        "storage_key": "property/6737460151192621/019e1e03-a1f7-735f-a442-c1c4625d15fe.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-cadLnm70ocRydZIE2kXnPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_ff1743f9-d06f-4224-8695-0ff9c317cc65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Main St & 5th St",
      "poi_type": "Transportation & Transit",
      "poi_address": "North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-8d10-744c-85d2-ac6adfdd6607.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-8d10-744c-85d2-ac6adfdd6607",
        "storage_key": "property/6737460151192621/019e1e03-8d10-744c-85d2-ac6adfdd6607.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1298157104827352373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-st--5th-st",
      "poi_latitude": "34.757531",
      "poi_longitude": "-92.26762200000002",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnbUHXIG80ocRNUXiRwL7AxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_7436800a-80ae-443c-8872-b37883c1e7c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1400 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-439c-710b-bdf7-edc455c09a32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-439c-710b-bdf7-edc455c09a32",
        "storage_key": "property/6737460151192621/019e1e01-439c-710b-bdf7-edc455c09a32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=LRK",
      "poi_directions_map_url": "https://maps.google.com/?cid=16485565726769375602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-station",
      "poi_latitude": "34.750483",
      "poi_longitude": "-92.28700990000002",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-50ed-725e-91d5-3269c8bffcf3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-50ed-725e-91d5-3269c8bffcf3",
        "storage_key": "property/6737460151192621/019e1e01-50ed-725e-91d5-3269c8bffcf3.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55EYqF-70ocRcmlxKa9-yOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_32a9ac71-354c-41f4-8eea-854d76b4e512",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "2 World Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-8fce-70bb-a614-05836e0ea2ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-8fce-70bb-a614-05836e0ea2ee",
        "storage_key": "property/6737460151192621/019e1e03-8fce-70bb-a614-05836e0ea2ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.greyhound.com/?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8801926884858579282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "34.7449296",
      "poi_longitude": "-92.2586711",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdDywoG80ocRUsn0_t25Jno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_dd78621e-1810-4400-aa31-aecb296a401e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Bill and Hillary Clinton National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Airport Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_long_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-935b-772a-bc29-25da1891819a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-935b-772a-bc29-25da1891819a",
        "storage_key": "property/6737460151192621/019e1e03-935b-772a-bc29-25da1891819a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.clintonairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7788752853462898252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-and-hillary-clinton-national-airport",
      "poi_latitude": "34.7315031",
      "poi_longitude": "-92.2233332",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 501-372-3439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-50f3-740a-9a61-ec0184ecf89c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-50f3-740a-9a61-ec0184ecf89c",
        "storage_key": "property/6737460151192621/019e1e01-50f3-740a-9a61-ec0184ecf89c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eIlS2C50ocRTFb3IXQ1F2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_0475fe0c-2a4b-45e4-9abd-d917816014d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "North Little Rock Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8200 Remount Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-3c76-739d-b7e0-8bdc3610ac27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-3c76-739d-b7e0-8bdc3610ac27",
        "storage_key": "property/6737460151192621/019e1e01-3c76-739d-b7e0-8bdc3610ac27.webp",
        "width": 1280,
        "height": 582
      },
      "poi_business_url": "http://nlr.ar.gov/government/a_z_department_list/airport/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14818561348559290970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-municipal-airport",
      "poi_latitude": "34.831655",
      "poi_longitude": "-92.2591882",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-835-5654",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-50f3-740a-9a61-ec0184ecf89c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-50f3-740a-9a61-ec0184ecf89c",
        "storage_key": "property/6737460151192621/019e1e01-50f3-740a-9a61-ec0184ecf89c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9wudIW90ocRWsI1zwgbps0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_63ba97db-6eda-40a2-aa83-ad6223703a24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "UAMS Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4301 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-3335-73b8-8073-3cb76a53cb51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-3335-73b8-8073-3cb76a53cb51",
        "storage_key": "property/6737460151192621/019e1e01-3335-73b8-8073-3cb76a53cb51.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://uamshealth.com/location/uams-medical-center/?utm_source=google&utm_medium=gmb&utm_campaign=clinical&utm_term=location&utm_content=profile&utm_specs=uams-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=980427499144927317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uams-medical-center",
      "poi_latitude": "34.7493145",
      "poi_longitude": "-92.3205392",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 501-686-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e69-775f-90f1-d2ac408658ab",
        "storage_key": "property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJz5GH8ql0ocRVdiOrp0tmw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_7c07b26e-6f7f-45ab-aeeb-6bd9f8d80f4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Arkansas Children's Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Children's Way, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-2fa0-76aa-8c6e-43b2d9e6b8cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-2fa0-76aa-8c6e-43b2d9e6b8cc",
        "storage_key": "property/6737460151192621/019e1e01-2fa0-76aa-8c6e-43b2d9e6b8cc.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.archildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800723640570466137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-childrens-hospital",
      "poi_latitude": "34.7430995",
      "poi_longitude": "-92.2918544",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 501-441-3453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e69-775f-90f1-d2ac408658ab",
        "storage_key": "property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5Fcp1q70ocRWc9Rbm9yR9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e2b707c6-1df7-448f-b678-f88d5ddea0b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Baptist Health Medical Center-Little Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9601 Baptist Health Dr, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-9250-74af-bcfe-37245aa80bf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-9250-74af-bcfe-37245aa80bf3",
        "storage_key": "property/6737460151192621/019e1e03-9250-74af-bcfe-37245aa80bf3.webp",
        "width": 1280,
        "height": 480
      },
      "poi_business_url": "https://www.baptist-health.org/find-care/location/Baptist-Health-Medical-Center-Little-Rock",
      "poi_directions_map_url": "https://maps.google.com/?cid=11761299314245094965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-medical-center-little-rock",
      "poi_latitude": "34.7441024",
      "poi_longitude": "-92.3811957",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 501-202-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e69-775f-90f1-d2ac408658ab",
        "storage_key": "property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_wGQvGm0ocRNc6fimmHOKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2c208064-7c58-4569-9a85-4d5f391398fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "John L. McClellan Memorial Veterans Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4300 W 7th St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-9548-73fe-b014-9b04c055b509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-9548-73fe-b014-9b04c055b509",
        "storage_key": "property/6737460151192621/019e1e03-9548-73fe-b014-9b04c055b509.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.littlerock.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10390625296849428833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-l-mcclellan-memorial-veterans-hospital",
      "poi_latitude": "34.746427",
      "poi_longitude": "-92.3204701",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 501-257-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-50f6-7372-977b-f0336c4cd659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-50f6-7372-977b-f0336c4cd659",
        "storage_key": "property/6737460151192621/019e1e01-50f6-7372-977b-f0336c4cd659.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVJqKk0ocRYeHl1KfqMpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f08c30f2-32eb-4af5-95d8-74db35b17c1d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "CHI St. Vincent Infirmary",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2 St Vincent Cir, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-929f-777c-8e40-abe0cb651de7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-929f-777c-8e40-abe0cb651de7",
        "storage_key": "property/6737460151192621/019e1e03-929f-777c-8e40-abe0cb651de7.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.chistvincent.com/hospitals-locations/chi-st-vincent-infirmary",
      "poi_directions_map_url": "https://maps.google.com/?cid=5554705797602066883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chi-st-vincent-infirmary",
      "poi_latitude": "34.7502877",
      "poi_longitude": "-92.3393435",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 501-552-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e69-775f-90f1-d2ac408658ab",
        "storage_key": "property/6737460151192621/019e1e01-4e69-775f-90f1-d2ac408658ab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJwaXYv4Gk0ocRw8HfKX5HFk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_42b86529-4e5f-44e6-b74f-f8e3ff11ba9d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Dillard's Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Cantrell Rd, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-3b00-75ff-8ea8-a483e0354915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e01-3b00-75ff-8ea8-a483e0354915",
        "storage_key": "property/6737460151192621/019e1e01-3b00-75ff-8ea8-a483e0354915.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11049574453805387583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dillards-corporate-office",
      "poi_latitude": "34.75433659999999",
      "poi_longitude": "-92.2878465",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 501-376-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96xpTae80ocRPw9NLmz5V5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_11641e32-41fb-4b50-bba9-e3b19de34303",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Heifer International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 World Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-966c-754d-be12-45ade0af2a13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-966c-754d-be12-45ade0af2a13",
        "storage_key": "property/6737460151192621/019e1e03-966c-754d-be12-45ade0af2a13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.heifer.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15947581606820737385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heifer-international",
      "poi_latitude": "34.7447963",
      "poi_longitude": "-92.2561293",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 855-948-6437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6hY55Wj0ocRaXEaPfowUd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_123f8d8a-dd04-4526-aefd-e26c61f6d188",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "University of Arkansas at Little Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-95c3-73d8-b467-386606d84c15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-95c3-73d8-b467-386606d84c15",
        "storage_key": "property/6737460151192621/019e1e03-95c3-73d8-b467-386606d84c15.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ualr.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13912235513023897276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas-at-little-rock",
      "poi_latitude": "34.7252717",
      "poi_longitude": "-92.3378705",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 501-916-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e21-719b-b750-0ba91e696d7f",
        "storage_key": "property/6737460151192621/019e1e01-4e21-719b-b750-0ba91e696d7f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL_aUdFik0ocRvB5dKX0wEsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6b8c4d2a-d436-48f7-8d2b-0a7c8b33e92a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "Winrock International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "325 W Capitol Ave suite 350, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-9b49-73ff-bddf-1adf79be7510.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-9b49-73ff-bddf-1adf79be7510",
        "storage_key": "property/6737460151192621/019e1e03-9b49-73ff-bddf-1adf79be7510.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.winrock.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9444094363833907050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winrock-international",
      "poi_latitude": "34.7442149",
      "poi_longitude": "-92.2743487",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-280-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-4e1f-75c7-b3b2-2f772b4167a2",
        "storage_key": "property/6737460151192621/019e1e01-4e1f-75c7-b3b2-2f772b4167a2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyAlB0yj0ocRareWdckpEIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_52b21db0-bd55-4e14-925d-d4400c618f87",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "custom",
      "poi_name": "North Little Rock City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Main St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e03-9b5a-74e8-8013-cf9e1d002fdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e03-9b5a-74e8-8013-cf9e1d002fdc",
        "storage_key": "property/6737460151192621/019e1e03-9b5a-74e8-8013-cf9e1d002fdc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nlr.ar.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16372710532587952868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-little-rock-city-hall",
      "poi_latitude": "34.7562244",
      "poi_longitude": "-92.267612",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-975-8601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-50f6-7372-977b-f0336c4cd659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e01-50f6-7372-977b-f0336c4cd659",
        "storage_key": "property/6737460151192621/019e1e01-50f6-7372-977b-f0336c4cd659.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk2g6XVG90ocR5JozqXuNN-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "custom_20a3a1b8-356c-48cf-979b-5ff4d330a7ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_2132d3e4-c3ef-4db2-a661-d729a46c1b84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_89f7c5da-0f5e-485e-8f14-d9c82bb6e456",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_2dbb3181-9920-4b9c-aeee-d006bbf0ef57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_a00b340d-497a-4882-a2d1-d161dea0a052",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_5f84c984-aedc-406b-86d0-f9185883cfd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "rating": "4",
      "name": "LaToya Bearden",
      "text": "The kids that live here attend Maumelle School District. The staff and maintenance work hard to make this a good place to live.",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_f73f1dd4-6bf3-4bec-aa5a-bd9a7296dd82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "rating": "5",
      "name": "Erica Howard",
      "text": "Love it here great quality and etc and they are great people here and they will understand what u going through and work with u been here 5 years and love it thanks u guy's for having me and my kids",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_849964d4-382c-4c5a-97b1-1e4bfc90018c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "rating": "5",
      "name": "Kae",
      "text": "I loveee my apartment at Wilmington! Very quiet & clean complex! Lucy was great literally from when I applied til i moved in! She made the process so easy and very fast !!",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_70c01e78-ad86-4369-886b-d57e02244d4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "rating": "5",
      "name": "Makayla Thomas",
      "text": "The new office manager and maintenance team are amazing. Anytime I need something, they’re very quick to fix the situation. They’re always smiling and polite as well. I also really enjoy the area it’s located and activities (dog park, pool, and playground) that they offer.",
      "date": "2026-04-10",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_6e7c96c6734a6eab984b49ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019e1e01-0b9c-730e-8529-08948c6756ec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e01-0b9c-730e-8529-08948c6756ec",
        "storage_key": "property/6737460151192621/019e1e01-0b9c-730e-8529-08948c6756ec.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=6683828ac5e71e10fda2acd1"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199df2d-82d1-743b-ad95-b0c02c513857",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-wilmington-apartments-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621"
    },
    {
      "lead_collector_id": "019a502e-4404-70ea-a41b-783775130df4",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-wilmington-apartments-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621"
    },
    {
      "lead_collector_id": "019d6351-d244-75fc-b0f3-e5fe0b0d36e9",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "page_item_url": "apartments-with-pool-north-little-rock",
      "search_query": "apartments with pool North Little Rock",
      "category": "Amenity",
      "h1_title": "Explore Apartments with Pool Access",
      "h2_subtitle": "Dive into comfort with Wilmington Apartments. Enjoy the pool and other stellar amenities at our North Little Rock community.",
      "page_copy": "If you're seeking apartments with pool access in North Little Rock, Wilmington Apartments is the perfect fit. Our vibrant community offers a range of spacious two, three, and four-bedroom floor plans, ensuring there's a home that's just right for you. Alongside the refreshing pool, residents can make use of our modern fitness center and clubhouse for recreational activities.\n\nNestled in the welcoming neighborhood of North Little Rock, Wilmington Apartments provides a tranquil yet lively living experience. While the highlight is certainly having a pool at your doorstep, our amenities including package service and in-home washer/dryer hookups add convenience to daily life. Discover the ease and comfort of life in our community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with beige siding, black shutters, and pitched roofs.",
        "public_id": "019d0783-dc48-744b-94ac-9118ebd99b81",
        "storage_key": "property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool Access in North Little Rock",
      "seo_description": "Find your home at Wilmington Apartments with pool access and more in North Little Rock. Spacious floor plans and great amenities await you!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-pulaski-county",
      "search_query": "air conditioned apartments Pulaski County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Pulaski County",
      "h2_subtitle": "Find comfort at Wilmington Apartments in Pulaski County, equipped with air conditioning and modern amenities to enhance your lifestyle.",
      "page_copy": "Searching for air conditioned apartments in Pulaski County? Wilmington Apartments in North Little Rock delivers comfort across our spacious two, three, and four-bedroom residences. Each home features efficient air conditioning, ensuring the perfect indoor climate all year round. Our community is more than meets the eye, boasting exceptional amenities such as a fitness center, a clubhouse, and a delightful roof terrace for leisure.\n\nLocated in the vibrant area of North Little Rock, Wilmington Apartments is the ideal place to call home. Our properties come with conveniences such as in-home washer/dryer hookups and a full kitchen with a range and dishwasher. Living in an air conditioned apartment enhances the overall quality of life, providing both comfort and convenience. Experience peaceful living in Pulaski County with us.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with beige siding, black shutters, and pitched roofs.",
        "public_id": "019d0783-dc48-744b-94ac-9118ebd99b81",
        "storage_key": "property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Pulaski County",
      "seo_description": "Wilmington Apartments in Pulaski County offer air conditioned spaces and top-notch amenities. Discover your perfect home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-north-little-rock-ar",
      "search_query": "apartments with dishwasher North Little Rock AR",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in North Little Rock",
      "h2_subtitle": "Enjoy modern living at Wilmington Apartments. Our homes in North Little Rock, AR come with a dishwasher for your convenience.",
      "page_copy": "For those searching for apartments with dishwasher facilities in North Little Rock, AR, look no further than Wilmington Apartments. Each of our spacious two, three, and four-bedroom units comes equipped with a dishwasher, making everyday meal clean-up simple and efficient. Our properties boast a range of other modern amenities including an in-home washer/dryer hookup and a full range oven, ensuring a comfortable and convenient living experience.\n\nWilmington Apartments, situated in the lively community of North Little Rock, offers residents not just a home but a lifestyle. Beyond the in-home amenities like the dishwasher, residents can enjoy a fitness center, a clubhouse, and a pleasant roof terrace. Embrace a hassle-free life with the convenience of easy cleanup at the heart of Pulaski County’s vibrant living spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with beige siding, black shutters, and pitched roofs.",
        "public_id": "019d0783-dc48-744b-94ac-9118ebd99b81",
        "storage_key": "property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in North Little Rock, AR",
      "seo_description": "Discover Wilmington Apartments in North Little Rock, AR. Enjoy the convenience of a dishwasher among other modern amenities. Find your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "page_item_url": "gym-equipped-apartments-72118",
      "search_query": "gym-equipped apartments in 72118",
      "category": "Amenity",
      "h1_title": "Gym-Equipped Apartments in 72118",
      "h2_subtitle": "Stay fit at Wilmington Apartments. Our 72118 community features a fully-equipped gym for all your workout needs.",
      "page_copy": "Looking for gym-equipped apartments in the 72118 area? Wilmington Apartments in North Little Rock offers a modern fitness center right within the community, perfect for all your exercise routines. Our spacious two, three, and four-bedroom floor plans ensure you and your family have plenty of room to enjoy both exercise and relaxation at home.\n\nNestled in a vibrant neighborhood, Wilmington Apartments provides more than just a place to live; it offers a lifestyle of health and convenience. In addition to the gym, residents can enjoy amenities such as a clubhouse and roof terrace, alongside practical features like in-home washer/dryer hookups and a full kitchen. Embrace a healthier lifestyle and enjoy all the benefits of having a gym just steps from your door in the heart of Pulaski County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with beige siding, black shutters, and pitched roofs.",
        "public_id": "019d0783-dc48-744b-94ac-9118ebd99b81",
        "storage_key": "property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gym-Equipped Apartments in 72118",
      "seo_description": "Find gym-equipped living at Wilmington Apartments in the 72118 area. Get fit with our convenient fitness center and smart living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "page_item_url": "family-friendly-apartments-playground-near-north-little-rock",
      "search_query": "family-friendly apartments with playground near North Little Rock",
      "category": "Amenity",
      "h1_title": "Family-Friendly Apartments Near North Little Rock",
      "h2_subtitle": "Discover Wilmington Apartments for family-friendly living near North Little Rock. Our community features a playground and other kid-friendly amenities.",
      "page_copy": "If you're in search of family-friendly apartments with a playground near North Little Rock, Wilmington Apartments is the perfect fit. Designed with families in mind, our community provides spacious two, three, and four-bedroom homes that cater to the needs of both adults and children. Whether it’s unwinding in our hassle-free home environment or letting the kids enjoy the playground, Wilmington offers the ideal setting.\n\nLocated in Pulaski County, our apartments provide more than just family-friendly indoor spaces. The community includes amenities tailored for the entire family's enjoyment, such as a fitness center and a clubhouse. With the convenience of practical features like in-home washer/dryer hookups and full kitchens, Wilmington Apartments ensures every family has the comfort and function they need.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with beige siding, black shutters, and pitched roofs.",
        "public_id": "019d0783-dc48-744b-94ac-9118ebd99b81",
        "storage_key": "property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments Near North Little Rock",
      "seo_description": "Live at Wilmington Apartments, a family-friendly community with a playground near North Little Rock. Spacious homes and amenities for all ages!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-north-little-rock",
      "search_query": "three bedroom apartments north little rock",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in North Little Rock",
      "h2_subtitle": "Explore spacious three-bedroom living in North Little Rock at Wilmington Apartments. Your ideal home awaits in a vibrant community.",
      "page_copy": "Looking for three bedroom apartments in North Little Rock? Wilmington Apartments offers spacious and comfortable three-bedroom layouts, perfect for families or those needing extra space. Located in a lively community, these homes are designed to provide ample room for all aspects of your life, whether you're entertaining guests or relaxing after a long day.\n\nAt Wilmington Apartments, residents can enjoy a host of amenities including a fitness center, clubhouse, and beautiful roof terrace. Inside each apartment, modern conveniences like a dishwasher, range, and washer/dryer hookups ensure everyday living is seamless. Settle into a community that offers both comfort and convenience in the heart of Pulaski County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with beige siding, black shutters, and pitched roofs.",
        "public_id": "019d0783-dc48-744b-94ac-9118ebd99b81",
        "storage_key": "property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Three Bedroom Apartments in North Little Rock",
      "seo_description": "Find your ideal three-bedroom apartment in North Little Rock at Wilmington Apartments. Enjoy spacious layouts and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "page_item_url": "four-bedroom-apartments-pulaski-county-ar",
      "search_query": "four bedroom apartments pulaski county ar",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments in Pulaski County, AR",
      "h2_subtitle": "Wilmington Apartments offers spacious four-bedroom living in Pulaski County, AR. Perfect for growing households and those desiring extra space.",
      "page_copy": "If you're searching for four bedroom apartments in Pulaski County, AR, Wilmington Apartments is the ideal choice. Our expansive four-bedroom floor plans are designed to provide comfortable and flexible living arrangements, accommodating growing families or anyone needing additional space. Nestled in North Little Rock, this community offers a perfect blend of convenience and tranquility.\n\nWith access to top-notch amenities like a modern fitness center, clubhouse, and roof terrace, Wilmington Apartments enhances your living experience. Residents also appreciate features such as in-home washer/dryer hookups, a full kitchen with a range and dishwasher, and package service. Experience the convenience and charm of living in a four-bedroom home within a lively community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with beige siding, black shutters, and pitched roofs.",
        "public_id": "019d0783-dc48-744b-94ac-9118ebd99b81",
        "storage_key": "property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in Pulaski County, AR",
      "seo_description": "Discover spacious four-bedroom apartments at Wilmington Apartments in Pulaski County, AR. Enjoy modern amenities and a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192621",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-72118",
      "search_query": "two bedroom apartments near 72118",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 72118",
      "h2_subtitle": "Explore two-bedroom living near the 72118 area at Wilmington Apartments. Experience comfort and convenience in a vibrant community.",
      "page_copy": "Searching for two bedroom apartments near the 72118 area? Look no further than Wilmington Apartments, where spacious living meets modern convenience. Perfectly located in North Little Rock, our two-bedroom floor plans are thoughtfully designed to offer both comfort and functionality, ideal for any lifestyle.\n\nAt Wilmington Apartments, residents enjoy a variety of amenities that enhance everyday living, such as a fitness center, clubhouse, and roof terrace. Each apartment features valuable in-home conveniences, including a dishwasher, range, and washer/dryer hookups, ensuring your daily routine is effortless. Experience vibrant community living in Pulaski County with a home that suits your needs and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with beige siding, black shutters, and pitched roofs.",
        "public_id": "019d0783-dc48-744b-94ac-9118ebd99b81",
        "storage_key": "property/6737460151192621/019d0783-dc48-744b-94ac-9118ebd99b81.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 72118",
      "seo_description": "Discover spacious two-bedroom apartments near 72118 at Wilmington Apartments. Enjoy modern living in a vibrant North Little Rock community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3417"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483301"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4654598"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PT44BN7Z"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "501-575-1038"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "501-302-4032"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "501-594-4674"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "501-300-6726"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "501-441-3348"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "501-500-5163"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "501-214-6334"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "501-214-5964"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "501-382-7959"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "501-271-3668"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "501-727-4151"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "501-725-6364"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "501-501-3394"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "501-200-9619"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "501-299-9416"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "501-474-6348"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "501-530-8876"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "501-382-8735"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321200797"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "501-263-2426"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "501-426-5882"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "75311eef836283a1"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "501-510-6619"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "501-361-3590"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "501-645-8799"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "501-382-1481"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "501-381-5282"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "501-503-3006"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "501-285-9495"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.liveatwilmington.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192621/019e849c-df59-716b-b92f-993b99e10513.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "501-441-3731"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "501-271-3668"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3417",
  "custom_repli_id": "5028483301",
  "custom_realpage_id": "4654598",
  "custom_knock_a_link": "https://www.liveatwilmington.com?utm_knock=a",
  "custom_knock_g_link": "https://www.liveatwilmington.com?utm_knock=g",
  "custom_knock_r_link": "https://www.liveatwilmington.com?utm_knock=r",
  "custom_knock_w_link": "https://www.liveatwilmington.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-PT44BN7Z",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.liveatwilmington.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.liveatwilmington.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.liveatwilmington.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.liveatwilmington.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.liveatwilmington.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.liveatwilmington.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "501-575-1038",
  "custom_knock_ads_link": "https://www.liveatwilmington.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.liveatwilmington.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "501-302-4032",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.liveatwilmington.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.liveatwilmington.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.liveatwilmington.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.liveatwilmington.com?utm_knock=psa",
  "custom_knock_r_number": "501-594-4674",
  "custom_knock_w_number": "501-300-6726",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "501-441-3348",
  "custom_knock_amap_link": "https://www.liveatwilmington.com?utm_knock=amap",
  "custom_knock_ar_number": "501-500-5163",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "501-214-6334",
  "custom_knock_fb_number": "501-214-5964",
  "custom_knock_fl_number": "501-382-7959",
  "custom_knock_gp_number": "501-271-3668",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.liveatwilmington.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "501-727-4151",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.liveatwilmington.com?utm_knock=bcard",
  "custom_knock_bnr_number": "501-725-6364",
  "custom_knock_cfres_link": "https://www.liveatwilmington.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "501-501-3394",
  "custom_knock_lgp_number": "501-200-9619",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.liveatwilmington.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "501-299-9416",
  "custom_knock_psa_number": "501-474-6348",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "501-530-8876",
  "custom_knock_bandit_link": "https://www.liveatwilmington.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.liveatwilmington.com?utm_knock=flyers",
  "custom_knock_osoc_number": "501-382-8735",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321200797",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "501-263-2426",
  "custom_knock_cfres_number": "501-426-5882",
  "custom_knock_chatgpt_link": "https://www.liveatwilmington.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "75311eef836283a1",
  "custom_knock_dirmail_link": "https://www.liveatwilmington.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "501-510-6619",
  "custom_knock_propbro_link": "https://www.liveatwilmington.com?utm_knock=propbro",
  "custom_knock_bandit_number": "501-361-3590",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "501-645-8799",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.liveatwilmington.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "501-382-1481",
  "custom_knock_dirmail_number": "501-381-5282",
  "custom_knock_propbro_number": "501-503-3006",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "501-285-9495",
  "custom_knock_maintenance_link": "https://www.liveatwilmington.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192621/019e849c-df59-716b-b92f-993b99e10513.mp4",
  "custom_knock_maintenance_number": "501-441-3731",
  "custom_ppc_tracking_phone_number": "501-271-3668",
  "custom_audioeye_site_id": "e9b881b0-e35d-48cf-a15b-27d7600be8fe",
  "custom_audioeye_site_hash": "11fd299cff89222ce9bad68adadcb25a"
};

export const generatedAt = '2026-11-03T18:16:30.982Z';
